var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _path10, _path11, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _path12, _path13, _rect2, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardsGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1028.231,
    height: 637,
    viewBox: "0 0 1028.231 637",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ac9ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0.319,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3eb6fb"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_46659",
    x: 0,
    y: 16,
    width: 651.127,
    height: 543.676,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.518
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#177bd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2061c9"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_18909",
    x: 513.355,
    y: 153.608,
    width: 483.391,
    height: 483.391,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.518
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_17531",
    x: 115.231,
    y: 320,
    width: 670,
    height: 307,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.518
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.753,
    x2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#17dbb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d5ada"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_17531-2",
    x: 343.231,
    y: 0,
    width: 685,
    height: 321,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.518
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48934",
    "data-name": "Group 48934",
    transform: "translate(-2834.769 -3771.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48933",
    "data-name": "Group 48933",
    transform: "translate(0 0)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2834.77, 3771.5)",
    filter: "url(#Path_46659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46659-2",
    "data-name": "Path 46659",
    d: "M24.989,0H428.138a24.989,24.989,0,0,1,24.989,24.989v295.7a24.989,24.989,0,0,1-24.989,24.989H24.989A24.989,24.989,0,0,1,0,320.687V24.989A24.989,24.989,0,0,1,24.989,0Z",
    transform: "translate(99 95)",
    fill: "#212121"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48932",
    "data-name": "Group 48932"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48931",
    "data-name": "Group 48931",
    transform: "translate(2933.768 3866.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48930",
    "data-name": "Group 48930"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48929",
    "data-name": "Group 48929"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48928",
    "data-name": "Group 48928"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_52338",
    "data-name": "Path 52338",
    d: "M313.16,87.914c-.366.63,1.1,1.241,1.42,1.421s.046,1-.41,1.6-.412.863.1.849c.424-.015,1.025.19.483.556s-1.054,1.011-.791,1.274c.164.162.864-.232.864.249s.205,1.011.483.981c.4-.059.674-1.1,1.157-1.1s.131,1.1-.176,1.773a1.07,1.07,0,0,0,.483,1.332c.175,0,1.771-.484,2.313-.484.557,0-.176,1.172-.425,1.348s.923,1.084.923,1.084c.658.377.423,1.636.175,2.5s-1.771.132-2.429.132c-.675,0-.059,1.273.482,1.581s-.132,1.83-.791,2.079a1.425,1.425,0,0,0-.922,1.405c.059.425,1.413.293,1.713.542s1.827.118,2.5.425c.654.308-1.408.556-2.446.615s-2.2,2.312-2.738,2.812c-.556.483.657.849,1.157.483a1.431,1.431,0,0,1,1.64-.307c.981.247,1.1-.485,1.215-1.1s3.061-.367,4.1-.25a8.586,8.586,0,0,0,4.509-1.332c1.288-.863-.179-.614-.849-.922s.867-1.277,1.83-2.372-.5-2.559-1.537-2.5l.016-.009c-1.025.059-.715.073-.966-.483s-.12-1.23-.5-1.464c-.352-.245-.483-2.251-.542-2.5s-1.347-.732-1.523-.981a23.686,23.686,0,0,0-2.987-2.929c-.673-.363-.483-1.768-.366-2.5s1.757-3.335,2.006-4.26-1.712-.749-2.929-.5-1.1.186-1.1-.176,1.275-1.64,1.831-2.562-3.295-.423-4.144-.307-.19,1.347-.556,2.255c0,0-.394.819-.673,1.288s-.542.366-.5-.234-.734.058-1.1.688",
    fill: "#3cb5fb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52339",
    "data-name": "Path 52339",
    d: "M191.275,125.532h-6.267a5.958,5.958,0,0,1-1.714,1.215c-.659.176-1.947,2.445-1.947,2.445l-4.275.117.249,1.889-5.183,2.313a4.734,4.734,0,0,1-1.947.249h0a.056.056,0,0,0-.013,0c-.673-.176-.38-1.348-.38-1.348s.922-1.1,1.288-1.464.366-2.621.366-2.621l-.673-3.836-1.947-1.4-.791-1.347-.981-.425-7.124-5.063-1.893.919-.908.117-.006,0h-.007l-2.19-.67-.919.613,0-.006-.008,0-.843-1.032-.725.609-.006-.007-.007.006-1.1-1.346h-3.1l-.552-2.007-.723.91-52.153.19-.38,2.372-.017,0v.008l-2.5-.694a17,17,0,0,1,1.154,4.353c.366,1.746-1.553,12.153,0,17.746s5.581,11.172,6.4,12.27,4.128,2.649,5.943,4.392a5.422,5.422,0,0,1,.469.513l4.232-.513,6.1,2.679,6.457.614-.248-1.209h.015v-.006l3.543.117.966,1.215A8.678,8.678,0,0,1,129,160.365c.452.794,1.879,3.19,2.756,3a.464.464,0,0,0,.159-.072,7.042,7.042,0,0,0,1.581-1.962h.011l0,0h1.713l5.124,7.818,3.1.659c-.011-.847-.893-2.358,1.289-4.847,2.557-2.928,6.4-3.191,9.6-2.738s2.925-.456,4.3-1.1,6.972.453,9.34.366,2.646,3.66,3.1,4.934,1.919,5.223,3.66,5.315.092-6.32-.908-9.6c-1.01-3.309.088-4.393.176-5.315s4.665-3.761,7.965-6.046,1.645-4.2,1-6.4c-.629-2.2,0-1.1.556-.732s.821.086,1.641-1.1a28.411,28.411,0,0,0,2.02-5.007c.849-1.83,2.075-1.7,5.007-2.679s2.062-2.08,1.332-3.178.251-1.945.5-3.045a.448.448,0,0,1,.133-.22h0Z",
    fill: "#3cb5fb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52340",
    "data-name": "Path 52340",
    d: "M122.416,157.076H122.4l.248,1.208h.015Z",
    fill: "#5fb3f4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52341",
    "data-name": "Path 52341",
    d: "M131.918,163.3a.472.472,0,0,1-.159.072.466.466,0,0,0,.173-.076,7.046,7.046,0,0,0,1.578-1.958H133.5a7.042,7.042,0,0,1-1.581,1.962",
    fill: "#5fb3f4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52342",
    "data-name": "Path 52342",
    d: "M94.393,116.916l-2.5-.695,0,.008,2.5.7Z",
    fill: "#5fb3f4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52343",
    "data-name": "Path 52343",
    d: "M148.231,115.456l-.556-2.019-.009.012.552,2.007Z",
    fill: "#5fb3f4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52344",
    "data-name": "Path 52344",
    d: "M168.04,121.738l.791,1.347,1.947,1.4.673,3.836s0,2.257-.366,2.621-1.288,1.464-1.288,1.464-.293,1.172.38,1.348a.056.056,0,0,1,.013,0c-.671-.176-.38-1.347-.38-1.347s.923-1.1,1.289-1.464.366-2.621.366-2.621l-.673-3.836-1.948-1.4-.791-1.347-.981-.425-7.13-5.067-.007,0,7.124,5.063Z",
    fill: "#5fb3f4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52345",
    "data-name": "Path 52345",
    d: "M154.007,117.222l-.844-1.033-.007.006.843,1.032Z",
    fill: "#5fb3f4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19191",
    "data-name": "Rectangle 19191",
    width: 0.005,
    height: 2.292,
    transform: "matrix(0.292, -0.956, 0.956, 0.292, 154.931, 116.617)",
    fill: "#5fb3f4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52346",
    "data-name": "Path 52346",
    d: "M152.425,116.8l-1.094-1.34h-.012l1.1,1.346Z",
    fill: "#5fb3f4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52347",
    "data-name": "Path 52347",
    d: "M191.276,125.532h0l2.885,2.885h0Z",
    fill: "#5fb3f4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52348",
    "data-name": "Path 52348",
    d: "M428.138,0H24.989a25.16,25.16,0,0,0-4.574.425A24.99,24.99,0,0,0,0,24.989v295.7a24.982,24.982,0,0,0,24.989,24.989H428.138a24.971,24.971,0,0,0,24.989-24.989V24.989A24.989,24.989,0,0,0,428.138,0M93.048,120.583a17.036,17.036,0,0,0-1.154-4.353l0-.009,2.5.695.017,0,.38-2.372,52.153-.19.723-.91.009-.012.556,2.019h3.1l1.094,1.34.006.007.725-.609.007-.006.844,1.033,0,.006.919-.613,0,0,2.194.671.006,0,.908-.117,1.893-.919.007,0,7.13,5.067.981.425.791,1.347,1.948,1.4.673,3.836s0,2.255-.366,2.621-1.289,1.464-1.289,1.464-.292,1.171.38,1.347h0a4.736,4.736,0,0,0,1.947-.249l5.183-2.313-.249-1.889,4.275-.117s1.288-2.269,1.947-2.445a5.958,5.958,0,0,0,1.714-1.215h6.268l2.885,2.884a.448.448,0,0,0-.133.22c-.249,1.1-1.23,1.947-.5,3.045s1.6,2.2-1.332,3.178-4.158.849-5.007,2.679a28.411,28.411,0,0,1-2.02,5.007c-.82,1.186-1.084,1.464-1.641,1.1s-1.185-1.464-.556.732c.645,2.2,2.3,4.115-1,6.4s-7.877,5.124-7.965,6.046-1.186,2.006-.176,5.315c1,3.28,2.649,9.692.908,9.6s-3.207-4.026-3.66-5.315-.732-5.021-3.1-4.934-7.965-1.01-9.34-.366-1.1,1.553-4.3,1.1-7.043-.19-9.6,2.738c-2.182,2.489-1.3,4-1.289,4.847l-3.1-.659-5.124-7.818h-1.713l0,0a7.046,7.046,0,0,1-1.578,1.958.466.466,0,0,1-.173.076c-.877.186-2.3-2.21-2.756-3a8.678,8.678,0,0,0-2.079-1.963l-.966-1.215-3.543-.117v.006l.248,1.209h-.015l-6.457-.614-6.1-2.679-4.232.513a5.422,5.422,0,0,0-.469-.513c-1.815-1.743-5.124-3.294-5.943-4.392s-4.847-6.677-6.4-12.27.366-16,0-17.746M315.989,83.917c.849-.116,4.7-.615,4.144.307s-1.831,2.2-1.831,2.562-.117.425,1.1.176,3.178-.425,2.929.5-1.889,3.528-2.006,4.26-.307,2.137.366,2.5a23.686,23.686,0,0,1,2.987,2.929c.176.249,1.464.732,1.523.981s.19,2.255.542,2.5c.38.234.249.908.5,1.464s-.059.542.966.483l-.016.009c1.039-.059,2.5,1.4,1.537,2.5s-2.5,2.064-1.83,2.372,2.137.059.849.922a8.6,8.6,0,0,1-4.509,1.332c-1.039-.117-3.968-.366-4.1.25s-.234,1.347-1.215,1.1a1.431,1.431,0,0,0-1.64.307c-.5.366-1.713,0-1.157-.483.542-.5,1.7-2.753,2.738-2.812s3.1-.307,2.446-.615c-.673-.307-2.2-.176-2.5-.425s-1.654-.117-1.713-.542a1.425,1.425,0,0,1,.922-1.405c.659-.249,1.332-1.771.791-2.079s-1.157-1.581-.482-1.581c.658,0,2.181.732,2.429-.132s.483-2.123-.175-2.5c0,0-1.172-.908-.923-1.084s.982-1.348.425-1.348c-.542,0-2.138.484-2.313.484a1.07,1.07,0,0,1-.483-1.332c.307-.674.659-1.773.176-1.773s-.761,1.041-1.157,1.1c-.278.03-.483-.5-.483-.981s-.7-.087-.864-.249c-.263-.263.249-.908.791-1.274s-.059-.571-.483-.556c-.512.014-.556-.249-.1-.849s.732-1.42.41-1.6-1.786-.791-1.42-1.421,1.142-1.288,1.1-.688.234.688.5.234.673-1.288.673-1.288c.366-.908-.293-2.139.556-2.255M17.23,98.62c-1.333-.249-2.2-.981.366-2.562s6.955-3.294,8.9-5.007,3.543-4.262,3.543-5.491-.132-1.581-2.2-1.7-3.177-.615-4.392-.132c-1.231.5-1.1-1.581-1.713-3.162s-3.3-.981-3.91-.981-5.124-5.008-3.411-8.3,3.051-5.974,5.13-5.974,4.51-.615,4.028-3.411c-.484-2.812-5.741-1.231-7.322-1.231,0,0-2.5.249-2.737-1.523a3.056,3.056,0,0,0-1.963-2.679c-.393-.182-.726-.454-.717-.817v-.012c.017-.366.383-.823,1.39-1.371,2.02-1.1,4.568-3.177,5.373-3.353s1.771-.074,1.947.542-.981,2.137,0,2.137,4.2-.366,3.544-1.654a12.061,12.061,0,0,0-3.544-3.28c-.556-.309-1.215-1.714-1.83-2.578s-3.294-2.372-3.6-3.045a9.1,9.1,0,0,1,0-2.928c.22-.513.029-.234,1.684-.337,1.64-.087,2.738-.819,3.747-2.825S21.286,32.817,23.028,32c1.727-.819,5.579-3.1,7.862-3.939,2.285-.819,3.47.19,5.857.835,2.386.629,4.582,2.928,7.233,2.548,2.649-.352,5.3,1.2,7.95,1.377s2.752.922,5.314.278c2.05-.512,2.46,1.259,4,2.167v0l-.337,42.486.333.1.545.166-.527,1.8h0A15.685,15.685,0,0,0,57.246,78c-2.562-.5-6.222-2.811-7.437-2.446-1.231.367-1.83,2.446-1.83,2.812s-3.91,2.313-5.008,2.679-1.464-.483-1.581-1.713-1.962-1.7-3.06.366,1.962,0,0,3.06A31.84,31.84,0,0,1,26.982,93.247c-5.608,3.06-8.419,5.622-9.752,5.373",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48777",
    "data-name": "Group 48777",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48776",
    "data-name": "Group 48776"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48775",
    "data-name": "Group 48775"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52349",
    "data-name": "Path 52349",
    d: "M414.956,199.647c-3.5,1.157-6.3.967-8.171-1.625a7.607,7.607,0,0,1-.612-1.018,2.33,2.33,0,0,0-.19-.337l-1,.1-.186.017-.908.922v1.574h0V197.7l.908-.922.19-.014,0,0,1-.1v-.006a9.146,9.146,0,0,0-.542-.908c-1.844-2.665-4.406-3.895-5.856-5.989a30.3,30.3,0,0,1-2.123-3.616l-.005,0a26.509,26.509,0,0,1-2.181-5.811,17.735,17.735,0,0,0-.775-2.356h-.006a64.014,64.014,0,0,0-4.522-8.254c-1.465-2.459-2.285-3.191-3.485-6.032-1.185-2.841,1.113-.279,1.567.732.381.833,1.026,1.1,2.358,1.039l-.073-2.782.249-.483a.583.583,0,0,1-.133-.307c-.024-.544-.463-2.55-.8-4a2.265,2.265,0,0,1-2.152.206c-2.474-.82-5.212.278-6.589.834-1.025.41-3.836-.41-7.76-1.962l-1.17,1.623,1.171-1.625c-1.319-.511-2.768-1.127-4.319-1.8-6.121-2.649-5.579,2.665-5.579,2.665.091,1.831-.924,2.563-2.109,2.285s-1.185-1.188-3.015-1.288a3.843,3.843,0,0,1-3.573-2.46c-.513-1.318-5.506-1.713-7.38-2.475l.089,1.947-2.431,1.6.059,1.889s-.893.835-1.435,1.347v0l0,0v0c.542-.513,1.43-1.344,1.43-1.344l-.057-1.889,2.429-1.6-.087-1.947h0a1.48,1.48,0,0,1-.22-.087c-1.64-.835-.819-2.754-.732-5.769.074-2.121-.412-2.929-1.112-3.221a2.381,2.381,0,0,0-.981-.161c-.352,0-1.1.045-2.109.132l0,0c-2.476.206-6.57.659-10.329,1.244-4.583.7-8.053,2.768-10.806,3.383a6.607,6.607,0,0,1-1.267.175c-2.924.1-4.2-1.64-5.124-1.552s.293,3.368-2.475,4.583c-4.847,2.094-4.481,6.764-4.671,8.507-.131,1.345-3.812,3.451-5.747,4.842h-.008a3.777,3.777,0,0,0-1.1,1.011c-.557,1.1-5.316,7.774-6.238,9.414a3.665,3.665,0,0,0-.615,2.66h0a32.455,32.455,0,0,0,1.171,4.655,8.194,8.194,0,0,1,.014,5.1l4.012-.6-4.009.6a15.635,15.635,0,0,1-1.845,3.23,8.528,8.528,0,0,0,.352,1.874l1.3.234,2.2-.089H298.1l1.01.542.82.19-.015.009-.806-.184-1.01-.542h-1.274l-2.2.087-1.3-.234a8.523,8.523,0,0,0,.542,1.494h.005a6.991,6.991,0,0,0,.55,1.072l5.33-.336,4.041.4v.005l-.029.718,3.763.263.542-.821,1.551,1.289,0,.005-1.549-1.287-.542.82-3.764-.264.029-.718-4.036-.395v-.006l-5.326.337a7.637,7.637,0,0,0,2.3,2.416c.176.117.337.22.483.337l0,.006a8.023,8.023,0,0,1,3,3.733h0c.218.57.335,1.052.452,1.418a14.445,14.445,0,0,0,2.9,3.1h0c2.313,2.02,5.49,4.275,7.672,4.348l.234-2.515-.234,2.519a2.188,2.188,0,0,0,1.317-.323c1.875-1.2,5.258-1.23,7.658-1.054,1.61.122,2.782.322,2.782.322a22.88,22.88,0,0,1,4.479-1.684l-.908-1.7-.1-4.846-.542-.176.087-1.846-.542-.453.044-.718h0l-.044.716.542.453-.087,1.846.542.176.1,4.845.908,1.7a9.683,9.683,0,0,1,1.025-.233,11.8,11.8,0,0,1,1.889-.263l.023-2.849-.019,2.85a8.283,8.283,0,0,1,4.319.537c1.732.9-.1,3.379,4.478,2.758a5.511,5.511,0,0,1,1.794-.024l.793-1.208V209.1s2.241-2.262,2.867-2.2a1.693,1.693,0,0,1,.707.294,1.656,1.656,0,0,0-.7-.29c-.614-.055-2.869,2.2-2.869,2.2v1.581l-.791,1.215c2.285.323,2.841,2.138,2.855,3.807a9.081,9.081,0,0,1-.293,2.372l2.87.044v0l-2.871-.044a5.4,5.4,0,0,1-.146.6c-.556,2.471-2.02,2.928-.556,4.671a54.478,54.478,0,0,1,3.456,4.509l.483-1.185h0l-.482,1.185c.439.655.835,1.285,1.172,1.9l1.932-1.508.7.482-.7-.481-1.932,1.508c.249.425.482.849.688,1.274h.006c.116.218.234.449.333.667l7.892-.673s.732,2.562.923,2.841,1.1,1.464,1.1,1.464l3.011-.1,0,.005-3.017.1s-.925-1.2-1.1-1.464-.924-2.841-.924-2.841l-7.892.673a31.226,31.226,0,0,1,2.125,6.458c1.2,5.037-1.816,7.965-2.826,13.28a6.931,6.931,0,0,0-.118,1.639c1.187-.391,2.431-1.01,2.651-.791l0,0c-.221-.217-1.464.4-2.648.791.117,4.583,4.216,8.4,4.788,9.795.629,1.549.263,8.138,1.917,10.7.424.674,1.011,1.609,1.611,2.693l0,0c1.713,3.046,3.719,7.306,3.793,10.484.087,4.3,7.041,2.372,13.352,1.64s10.894-9.693,12.9-12.168a5.748,5.748,0,0,0,1.61-3.73h0c0-1.846-1.1-2.709,2.24-3.866,3.178-1.084,2.3-5.432.938-8.96a1.372,1.372,0,0,1-.059-.732c.512-2.7,8.843-5.784,10.747-9.693,1.039-2.167.249-5.359-.645-9.166l0,0-3.207,1.464-.919-.087,0,0,.922.087,3.207-1.464a39.612,39.612,0,0,1-1.465-10.923l-.007-.005a2.374,2.374,0,0,1,0-.316c.06-1.274,1.666-3.411,3.866-5.739l-1.215-1.215.088-7.233s.817-.779,1.768-1.6h0c-.951.823-1.769,1.6-1.769,1.6l-.088,7.233,1.215,1.215a123.672,123.672,0,0,1,11.113-10.221c2.8-2.28,6.707-10.863,7.16-13.88.469-3.016-2.65-.644-6.588.645m-115.483-1.458-1.464.089.005-.006,1.46-.089Zm112.743,6.491c.819,0,3.294.264,3.294.264h0c-.1-.01-2.475-.262-3.291-.262-.833,0-4.216-1.933-4.845-2.109l0,0c.633.178,4.011,2.108,4.846,2.108m-23.705,35.057v0l-.819.908v0Zm-.087,3.658v0l-.922.263v1.2l-1.01.907h0l1.01-.908v-1.2ZM386.2,259.564l.176,1.756Zm1.215-1.231-.366-2.005Zm-.058-4.144a3.968,3.968,0,0,1-.184,1.8,3.983,3.983,0,0,0,.183-1.8c-.187-.637.212-1.488-.066-2.1.278.614-.12,1.465.067,2.1m-31.3-39.111-.483,1.771-2.079-.615-1.4-.176-.571,0,.569,0,1.4.176,2.079.615.483-1.771-.133-.138Zm40.331-23.237.005,0-.8,1.271-1.859-.16v0l1.858.161Zm-5.123,24.821-1.742-4.536-.7.7-2.08.175-1.039.616-.732-.675-1.888.557-2.2-2.078-.542.556-1.039-.366-.615.542-2.212-1.728-1.391.088-.732-.307-1.156-.366v0l1.157.366.732.307,1.391-.087-.044-.044v0l.042.043,2.212,1.728.615-.542,1.039.366.542-.557,2.2,2.08,1.889-.556.732.673,1.039-.615,2.08-.176.7-.7h0l1.742,4.538Zm-7.981,19.1c-.484-.953-1.239-2.465-1.356-2.713a4.789,4.789,0,0,0-1.186-1.011h0a4.8,4.8,0,0,1,1.185,1.009C382.041,233.293,382.8,234.809,383.281,235.761Zm-4.109,2.96v.008l-.818-1.1,0,0Zm-8.786,2.015h0l-.089,3.932h0Zm-3.95-40.054h0l-.134-.91h.005Zm-5.124,3.295h0a3.129,3.129,0,0,0-.3-.838h0a3.085,3.085,0,0,1,.3.837m-6.3,10c.015.019.044.05.064.074-.021-.024-.051-.056-.066-.075-.213-.266-1.076-1.113-1.6-1.645.528.532,1.392,1.379,1.606,1.646m15.444-23.535-1.709-.191,0-.006,1.707.182Zm16.708,13.531,2.255-.19-.059-1.83.114-.954-.1.964.059,1.83-2.255.19-.233,1.516-.01,0Zm2.205,2.149.61,1.205h0l-.611-1.205Zm1.646,1.52.008,0v2.245h-.008Zm-3.3-8.253.307-2.492h0l-.306,2.494Zm-2.249-1.937.725.726v.007l-.732-.732Zm-10.122,11.46,1.139.306v0ZM367.4,192.758l.061.217-.065-.219.879-1.042Zm-.731,1.463h0l.605-.517Zm.473.733-.891,1.276h-.01Zm.565,1.347-.013.448.011-.448Zm.482,14.884.922.059.483.234,1.464-.967h.791l.133.293.541.073v0l-.542-.073-.132-.293h-.791l-1.464.966-.483-.234-.921-.059Zm4.864,31.007h0l-.232-.758Zm8.5,1.834-.364-.9-1.186.176-1.185-.542v-.008l1.185.541,1.186-.176.365.908Zm-.6-21.071.468-.342-.468.343Zm1.447,2.622-.044-.893-.085-.01.086.01h.006l.044.891h.8l-.132.791h0l.132-.79Zm.256-.864h0l.669-.6-.425-1.1-.38-.937h.005l.381.935.425,1.1Zm8.222-13.971,0,0,1.039.059.307.673.585.044-.086-1.44h.008l.087,1.446h-.01l-.587-.047-.307-.673Zm-36.338-4.918a.512.512,0,0,1-.19.527,18.533,18.533,0,0,0-1.962,2.02,29.753,29.753,0,0,0,.615,3.543c.024.029.068.077.128.14-.061-.064-.106-.113-.13-.142a29.734,29.734,0,0,1-.615-3.544,18.529,18.529,0,0,1,1.962-2.02.512.512,0,0,0,.19-.527q-.127-.476-.3-.938.176.464.31.942Zm-2.582-4.537s-.208,0-.235.177c.025-.181.238-.181.238-.181h2.869c-.009-.01-.014-.023-.022-.033.01.012.018.025.028.037Zm-.243-5.81a1.622,1.622,0,0,1,.073.214,1.428,1.428,0,0,0-.075-.213Zm-.492,3.682c.2-.071,1.525-.183,1.525-.671l0,0a3.6,3.6,0,0,0-.6-1.6.811.811,0,0,1-.135-.286.847.847,0,0,0,.136.286,3.5,3.5,0,0,1,.6,1.6c0,.483-1.333.6-1.523.674a9.732,9.732,0,0,0-.6,1.2,10.347,10.347,0,0,1,.6-1.209m-.478-4.812a.767.767,0,0,1,.293.1l-.2-1.214.2,1.216a.682.682,0,0,0-.293-.1,1.246,1.246,0,0,0-.9.356,1.241,1.241,0,0,1,.894-.358m-.123,6.031a9.664,9.664,0,0,0-.432,1.286.663.663,0,0,1-.022.116c-.007.024-.024.042-.033.065a.628.628,0,0,0,.051-.173,10.149,10.149,0,0,1,.436-1.294m-2.133,3.6.851-.365v0l-.849.366c-.2.435-.37.879-.531,1.328.16-.45.333-.895.529-1.331m.9-1.766h.006l-.039.925Zm12.087,8.478,1.347-.059,1.215,1.1,2.5.673,1.156.176h0l-1.157-.176-2.5-.673-1.215-1.1-1.347.059Zm.678,22.547h1.83v.542l2.387.19.176,4.026.556,1.187.176,2.2.74-.154-.747.157-.175-2.2L366.55,238l-.176-4.026-2.386-.191v-.541h-1.826ZM367.4,254c.323-.073,1.04-.207,1.669-.307l-2.151-2.152v0l2.152,2.152c.322-.058.629-.1.835-.117a17.381,17.381,0,0,1,2.679.132c.249.058,1.713.175,1.962.234a.061.061,0,0,1,.055.054.064.064,0,0,0-.055-.052c-.249-.058-1.713-.175-1.962-.234a17.507,17.507,0,0,0-2.679-.132c-.206.017-.513.058-.835.117l.009,0c-.63.107-1.347.234-1.669.307-.483.132-3.412.307-4.027.439h-.008c.616-.133,3.543-.307,4.025-.44m-2.648,1.745c-.017-.356-.03-.571-.03-.571h0c0,.012.013.221.029.571m14.728-3.866a3.365,3.365,0,0,0-1.83.732,8.977,8.977,0,0,0-1.654,1.8l-1.566-.045c-.117.161-.249.307-.249.307l-.365,1.285v0l.366-1.289s.128-.142.244-.3h0v0l1.566.043a8.921,8.921,0,0,1,1.654-1.8,3.365,3.365,0,0,1,1.83-.732Zm-.059-1.464v0l2.928-.865-.022-.39.023.394Zm3.876-14.645c.218.434.375.753.379.76l-.007,0-.377-.756Zm5.768-15.7,0,0v2h0Zm6.042-8.34h.006l1.52,1.768h-.007Zm5.848-19.093,0,0h-3.539l0,0Zm-6.338-5.254h0l-.132,2.194-.791,1.771.02,1.108-.024-1.1.791-1.771ZM371.5,160.787l.541-.92Zm-1.23,20.981h1.958v0h-1.958ZM353.708,175.9c.033-.021.068-.036.1-.056-.034.021-.069.036-.1.057l.671,4.539.829.621-.366,1.575-.366,5.66-1.531,1.711,1.525-1.708.366-5.666.366-1.567-.829-.627L353.7,175.9l.007,0m-3.323-.586c.48.117,1.427,1.352,1.8,1.361h0c-.366,0-1.317-1.245-1.8-1.362-.035-.009-.09-.02-.138-.03.052.01.11.021.146.03m-3.484-2.2a9.866,9.866,0,0,1,1.068,1.771.19.19,0,0,0,.03.044l.232.033-.241-.033a.181.181,0,0,1-.024-.037l0,0a9.9,9.9,0,0,0-1.068-1.771c-.176-.073-2.562-.981-2.562-.981l-1.157-3.119h0l1.156,3.114s2.386.908,2.562.981m-2.986-10.25.028,2.754-.029-2.749s-.966-1.6-.849-1.771h0c-.108.182.849,1.767.849,1.767m-1.353-6.585c-.025-.012-1.248-.589-1.828-.957.6.373,1.828.955,1.828.955Zm-9.3,27.213.085-.014-.1.016v.005l-1.831.32v0Zm-29.947,8.1v.645l-1.063-.059,0-.005,1.067.059V191.6Zm-.631,3.1.262-1.546h0l-.262,1.545Zm15.273-36.324.919.365h0l-.919-.365Zm5.766-2.821-.642.452v0l.641-.451ZM315.127,197.9l.453,1.1h0Zm13.8-6.866-3.051.25v0Zm.29-9.6,2.2.922v0l-2.2-.921-2.2-1.919-10.249-7.775-.425-.249-3.146.059v0l3.144-.059h0l.425.249,10.248,7.775Zm-28.92,8.052h0l1.441,2Zm3.546,6.233.026-.46Zm1.77-5.13-.732,1.011-.732-.908h-.922v-.005h.922l.732.908.732-1.01s9.518.1,9.781-.176a.99.99,0,0,0,.182-.555,1,1,0,0,1-.183.559c-.263.276-9.78.176-9.78.176m3.747,17.2.732-1h0l-.731,1Zm1.623-4.771-1.083-.611,0-.007Zm-1.348,2.894-.186.042.185-.042Zm.632-6.179.087,1.1h0l-.087-1.091-1.184-.366,0-.006Zm-4.3,4.135-.006.105Zm7.961-2.847-.73-1.1.731,1.1Zm1.283-.443-.006.078h0Zm2.5,1.112.8-.215Zm5.2-2.953-2.752.908-.074,2.62.074-2.62,2.752-.908h0Zm8.39,3.957a1.975,1.975,0,0,0-.577.2,1.947,1.947,0,0,1,.578-.2.3.3,0,0,0,.184-.1.3.3,0,0,1-.185.1m1.252-2.175a6.531,6.531,0,0,0-.178-2.143,6.434,6.434,0,0,1,.178,2.143m.9-5.44.9-.925h.006Zm7-.133a3.1,3.1,0,0,1-2.928-.366,2.989,2.989,0,0,0-1.331-.437,2.988,2.988,0,0,1,1.331.436,3.1,3.1,0,0,0,2.928.366.711.711,0,0,1,.66.108.716.716,0,0,0-.66-.107m3,.794c.353-.163.722-.4,1.106-.583-.384.187-.752.421-1.106.583m3.076,20.771.026-.394,3.484-.044h0l.16,1.813,2.08-.117.249.908-1.039.791-.059,1.1,1.1.425-.19,1.773-.309,1.83-.79.059.788-.059.307-1.83.19-1.771-1.1-.425.059-1.1,1.039-.791-.249-.908-2.079.121-.161-1.816-3.484.044Zm.995,10.59h0l.73-.614L346.9,225.7l-.176-1.215h0l.176,1.215,1.347.791Zm1.289-2.387h0l.176-1.332,0,0Zm.966-.117h.846l.5-.542v0l-.5.539Zm-.907,6.4h0l.058-1.4,0,0Zm2.491-2.811-.6.981,0,0,.6-.98.981-.059h0Zm4.334-1.4-2.679,2.5-.483-.059.479.058,2.679-2.5-.117-2.562s.22-.2.472-.437c-.25.24-.468.438-.468.438Zm4.158-12.2c-.366.366-.791,2.738-.981,3.294a19.121,19.121,0,0,0-.059,3.237L357.1,222.4s-.307.382-.307.556a.6.6,0,0,1-.141.214.575.575,0,0,0,.137-.215c0-.19.307-.556.307-.556l1.713-1.274a19.121,19.121,0,0,1,.059-3.237c.19-.556.615-2.928.981-3.294a1.889,1.889,0,0,0,.352-.981l-3.411-.176,3.411.176h0a1.892,1.892,0,0,1-.352.981m-8.421,38.67,0,0h8.593l0,0Zm7.184,23.25c-1.093-.248-.967-1.7-.966-1.711l0,0s-.132,1.464.966,1.713a7.777,7.777,0,0,0,2.267.3,7.762,7.762,0,0,1-2.27-.3m20.866-.113c-.005-.007-.014-.012-.02-.019s.013.009.018.015l0,0Zm-1.366-.089a.784.784,0,0,1,.081-.082.738.738,0,0,1,.116-.057.9.9,0,0,0-.2.139m-.215.323L376.71,277.7l-.395,1.377v0l.4-1.376,1.186-1.069a.9.9,0,0,1,.184-.285.9.9,0,0,0-.182.289m2.78-13.529a15.3,15.3,0,0,1-2.167.483c-1.228.117-2.328,2.2-2.328,2.562a2.121,2.121,0,0,1-1.948,1.581c-1.215,0-.615.481-.848,1.581-.25,1.1-2.691.865-4.891-.483a12.557,12.557,0,0,0-.483,1.831c0,.366-1.947,1.713-1.947,1.713H364.1l.249-2.2-1.462-1.944v-5.507h0v5.5l1.464,1.947-.249,2.2h1.957s1.947-1.347,1.947-1.713a12.574,12.574,0,0,1,.483-1.83c2.2,1.347,4.641,1.583,4.891.483.233-1.1-.366-1.581.849-1.581a2.12,2.12,0,0,0,1.947-1.582c0-.362,1.1-2.445,2.328-2.562a15.3,15.3,0,0,0,2.167-.483l-.469-1.112L380,261.9l.212.086.469,1.112a4.423,4.423,0,0,1,.879-.132,12.387,12.387,0,0,1,2.252.4h0a12.411,12.411,0,0,0-2.255-.395,4.412,4.412,0,0,0-.878.132m5.023,9.264-.483,1.333-1.947-.966h0l1.947.966.483-1.332-.366-1.962-.117-4.026-.98-2.926h0l.981,2.928.117,4.027.366,1.959Zm1.523-25.7-4.933,1.846v0l4.933-1.844v0l1.2.644,1.376.088.176.922-.176-.921-1.377-.088Zm5.588.56c-.645-.64-2.475-1.187-2.562-1.64-.048-.221-.212-.885-.317-1.545.107.659.273,1.322.321,1.542.088.453,1.919,1,2.562,1.64h0Zm-1.46,5.575a26.484,26.484,0,0,0-1.83-2.65c-.182-.115.068-.857.263-1.36-.2.5-.443,1.244-.261,1.359a26.675,26.675,0,0,1,1.828,2.648Zm4.48-10.527a10.855,10.855,0,0,1-2.752-.542c-.63-.366-2.46.542-3.016.732,0,0-.007.011-.012.013s.005-.008.008-.009l.4-.923a17.589,17.589,0,0,1-.2-1.816c0-.556-.922-1.464-.922-1.464l-1.549.206,0-.005-.276-.487.008,0,.278.483,1.552-.206s.922.908.922,1.464a17.6,17.6,0,0,0,.2,1.816l-.395.922c.556-.19,2.386-1.1,3.015-.732a10.848,10.848,0,0,0,2.751.542Zm7.143-29.347-1.032-.843,0,0,1.035.846h-.006",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48780",
    "data-name": "Group 48780",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48779",
    "data-name": "Group 48779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48778",
    "data-name": "Group 48778"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52350",
    "data-name": "Path 52350",
    d: "M419.624,246.868a7.175,7.175,0,0,0-1.4-3.031.521.521,0,0,0-.835.03c-.819,1.215-1.361,3.572-3.25,4.831-2.2,1.464-5.125,1.1-5.491,3.836-.366,2.754,0,4.044-.366,6.238s-1.64,2-1.64,4.2.176,5.125,1.64,6.223,5.681,1.107,6.955-3.837,3.66-10.438,3.66-12.444-.014-3.119.542-3.119.732-.453.19-2.928Z",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48783",
    "data-name": "Group 48783",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48782",
    "data-name": "Group 48782"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48781",
    "data-name": "Group 48781"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52351",
    "data-name": "Path 52351",
    d: "M424.268,25.887c1.215.249,1.332,2.926,1.947,4.026.513.939,4.246.91,6.34.5a.68.68,0,0,0,.453-1.039,51.256,51.256,0,0,1-2.884-4.7c-.982-1.947-.367-3.293,2.679-12.079a26.1,26.1,0,0,1,4.688-8.354,29.814,29.814,0,0,0-5.8-2.553c-.189,1.737-6.864,17.54-9.025,19.937-2.192,2.431.385,4.013,1.6,4.262",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48786",
    "data-name": "Group 48786",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48785",
    "data-name": "Group 48785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48784",
    "data-name": "Group 48784"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52352",
    "data-name": "Path 52352",
    d: "M452.279,25.9c-.563,1.352-1.151,2.693-1.779,4.016-.585,1.462.467,4.176,2.1,6.821V30.281a30.164,30.164,0,0,0-.322-4.383",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48789",
    "data-name": "Group 48789",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48788",
    "data-name": "Group 48788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48787",
    "data-name": "Group 48787"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52353",
    "data-name": "Path 52353",
    d: "M448.553,38.1c-2.2-2.445-5.606-2.811-8.169-3.909s-3.778.122-2.563.732,2.313,3.661.234,4.51a23.008,23.008,0,0,1-6.457,1.23c-2.2.234-2.561,1.1-5.49-.366s-7.335,2.431-10.381,6.091-2.315,3.426-3.779,2.694a1.282,1.282,0,0,1-.542-.5l-.014,0c-.559-1,.348-2.7,1.644-3.4,1.581-.849-1.83-3.543-2.562-4.026h0c-.732-.483-2.079,1.947-2.445,4.275a8.649,8.649,0,0,0,.409,3.676l.014,0a8.917,8.917,0,0,1,.48,2.2c0,1.361-1.1,1.084-2.929.176s-4.582,3.107-5.68,4.026,0,1.377,1.011,3.119-3.382.73-5.125-.367-2.2.19-1.464,1.377,1.828,1.818,2.109,2.738-.919.92-1.919.82a5.884,5.884,0,0,1-3.484-3.017,41.6,41.6,0,0,1-.645-6.047c-.087-1.361-2.473-2.27-3.66-4.012s-.643-1.291-.087-1.01S390,50.567,394.2,52.486s5.3,1.1,7.218-.732S402.81,49.47,402.709,47s-4.5-3.938-7.144-6.5a9.429,9.429,0,0,0-6.868-3.1,14.889,14.889,0,0,1-5.256-2.079l.044.892h0l-.044-.883v-.015A20.545,20.545,0,0,1,381.65,34.2c-.732-.556.453-1.377,1.83-1.917,1.376-.556-.732-1.919-1.377-2.109l-.005,0c-.629-.19-4.481-1.919-5.388-1.919a17.313,17.313,0,0,0-6.046,1.464,31.051,31.051,0,0,1-7.409,3.017c-3.573,1.011-6.223,6.032-6.955,7.775-.6,1.421-1.3,2.826-2.342,4.934-.234.483-.483,1-.762,1.567-.556,1.128-1.7,3.338-2.987,5.769-2.153,4.056-4.744,8.755-5.71,10.249C342.946,65.4,338.73,67.6,338.73,67.6c-2.841,2.562-3.939,3.484-3.485,4.495s.191,5.857.279,10.059S340.2,86,341.2,85.356a34.2,34.2,0,0,0,3.938-3.749c1.114-1.128,1.362-.147,1.508,1.01l.377-.1v0l-.38.1a9.556,9.556,0,0,0,.307,1.728c.469,1.185,2.02,4.026,2.386,6.309a19.465,19.465,0,0,0,.5,2.329c.351,1.127.864,1.889,1.786,1.889,1.46,0,1.654-1.743,3.66-2.475s1.655-4.935,1.655-6.311,1.376-2.928,3.294-3.939.546-4.3-.454-5.211c-1.009-.923-2.109-1.845-2.02-3.851s2.562-6.121,4.671-7.965a9.292,9.292,0,0,0,3.1-5.388,13.734,13.734,0,0,1,2.2-5.037c.571-.731,1.551-.542,2.617,0l0,.008a17.086,17.086,0,0,1,2.5,1.64c1.83,1.377-.536,3.017-1.551,3.939s-3.852,4.772-5.315,5.959-.626,2.459-.263,3.836.176,4.218.263,6.135c.106,1.918,2.126,2.827,3.4,3.471s3.193-1.552,6.311-2.563a8.449,8.449,0,0,1,1.771-.4c1.83-2.285,6.355-7.98,7.014-9.21.819-1.55-2.738-3.85-2.738-3.85l1-1.362-.82-.922-.087-2.2h-.732l-.279-.645.542-.629-.453-.366.19-2.2.013,0-.191,2.193.454.365-.542.63.279.645h.732l.087,2.2.82.922-1,1.361s3.558,2.3,2.738,3.851c-.659,1.23-5.183,6.926-7.013,9.209a2,2,0,0,1,2.166.849c.264.382,1.83.558,2.284,1.011s-.819.453-1.64.453c-.633,0-1.146,1.055-2.2,1.48l.352.718s-1.364,1.2-1.464,1.742a15.279,15.279,0,0,0,.556,2.929l-.689,1.815-.043.1.556.556-.279,1.743.589-.162-.593.164.279-1.743-.556-.556.043-.1-.6.1v0l.6-.1.689-1.816a15.279,15.279,0,0,1-.556-2.929c.1-.542,1.464-1.742,1.464-1.742l-.352-.718h0a2.406,2.406,0,0,1-1.2.176,22.491,22.491,0,0,0-5.856.278c-1.1.265-1.567,1.479-1.377,2.841s1.654,1.362,1.743,1.918a2.236,2.236,0,0,1,0,.542l1.508-.542h0l-1.507.542c-.032.981-.279,2.8-.732,2.928-.542.191-1.1-.174-1.919-1.274a1.749,1.749,0,0,0-.235-.22,1.721,1.721,0,0,0-2.414.308,7.624,7.624,0,0,0-1.216,4.554l.381.029,1.654-1.288,1.962.454,1.977.366,1.377-.82.007.127-.007-.125-1.377.819-1.976-.366-1.963-.453-1.654,1.288-.38-.029c0,.205.015.425.029.658.058.9.132,1.5.191,1.9l.673.073,1.141.776,1.05-.088-1.048.1-1.141-.776-.673-.073c.131.849.146.776-.469.849a1.084,1.084,0,0,1-.528.2c-.236,0-1.041.249-1.1.805a1.418,1.418,0,0,1-.364.948h-.006a2.416,2.416,0,0,1-1.157.571c-1.4.366-1.157-.981-1.348-1.464-.175-.5-1.157-.308-2.006-.132a24.217,24.217,0,0,0-4.085,2.328,2.092,2.092,0,0,1-1.83.146v0a4.138,4.138,0,0,1-.917-.452c-.908-.614-.058-1.288-.483-1.4s-3.12,1.581-3.969,1.947-.292-1.1-.234-1.464-.615.19-1.347.19c-.512,0-.912-.864-1.112-1.493l-2.182-.161a9.27,9.27,0,0,1-.073,3.221c-.293.555-1.84.911-2.749,1.111h0c-.2.043-.377.085-.493.115a11.86,11.86,0,0,0-2.665.644c-.454.368,0,1.1.059,1.553.044.469.044.835-.469.835-.5,0-.395-1.274-.673-1.464s-.512.542-.645,1.054a18.97,18.97,0,0,1-2.2,3.617,2.124,2.124,0,0,1-.322.292l.834.5h0l-.835-.5a7.479,7.479,0,0,1-1.45.761l.513.762.922.19.307,1.215,1.274.059.132,1.171.542.059.483-.791.5,1.581.967.425.337.015-.088-1.231.936-.438-.935.438.087,1.23,1.069.044.079.054-.082-.05-1.069-.044-.337-.014-.965-.425-.5-1.581-.483.791-.542-.059-.132-1.171-1.274-.059-.306-1.215-.923-.19-.512-.762c-.509.206-1.007.381-1.3.542-.673.366-.453,1.962-1.184,2.475s-2,1.878-2.606,2.2-1.363-.233-2.33-1.054-.191,1.874-.059,2.24c.148.366-.452.863-1.185.819a16.236,16.236,0,0,0-4.391-.176c-1.422.307-.41,1.771-.176,2.416.219.644,2.371.41,3.337.819.952.425,2.694,2.108,3.294,5.315a5.866,5.866,0,0,1-1.846,5.4c.542.615,1.435,1.42,1.435,1.42l2.782.776,1.744-.087a5.273,5.273,0,0,0,1.14.732,28.041,28.041,0,0,0,2.826-.044,5.006,5.006,0,0,1,.249-1.977c.586-1.634,3.6.132,4.979.366s2.108-1.141,2.708-1.83c.014-.015.029-.029.043-.029l.03-1.011-1.288-.059V125.96l-.482-.615,0,0,.481.612v1.581l1.288.059-.029,1.01a4.645,4.645,0,0,1,4.2-.571c1.508.6,2.02,2.973,2.342,3.573a2.531,2.531,0,0,0,.249.307,36.918,36.918,0,0,0,4.408,3.4c1.1.688,4.349,3.339,4.671,4.261a2.976,2.976,0,0,1-.41,2.518,1.375,1.375,0,0,0-.263.673.748.748,0,0,0,.307.557c.323.277,1.187-.64,1.7-1.64.5-1.01.776-1.933.263-2.753s.279-1.509.513-1.742c.217-.22,1.273,1.2,1.917,1.566.542.307.659-.468.659-.981a1.446,1.446,0,0,0-.014-.263c-.044-.41-3.66-2.372-4.393-2.885-.732-.5-.556-1.039-.556-1.039a8.748,8.748,0,0,1-1.727-.322c-.6-.234-3.207-3.763-3.939-4.582a5.206,5.206,0,0,1-1.011-2.651,2.567,2.567,0,0,1,1.611-2.24,1.265,1.265,0,0,1,.67-.233c.219.014.176.293.147.629h0a2.37,2.37,0,0,0-.044.468l0,.049a1.011,1.011,0,0,0,1.1.917c.366-.044.366-.733.556-.659a1.4,1.4,0,0,1,.8.878,9.988,9.988,0,0,0,1.157,2.386c.821,1.1,1.963.865,3.281,2.372a.267.267,0,0,0,.1.087v0a7.846,7.846,0,0,0,2.036.908,9.451,9.451,0,0,1,.5-1.611.907.907,0,0,1,1.025-.615,5.909,5.909,0,0,1-.117-1.157c.056-.191.556-.132.556-.132l-.981-1.025h0l.984,1.03s-.5-.058-.556.132a5.912,5.912,0,0,0,.117,1.156l0,0a.907.907,0,0,0-1.025.615,9.451,9.451,0,0,0-.5,1.611,2.922,2.922,0,0,1,1.537,1.361,4.509,4.509,0,0,0,.366-.776c.059-.307,1.084-.366,1.084-.366l.672-.863.007,0-.673.865.615.482.307.85.013.125h0l.1.849-.117,1.1.907,1.053h0l-.907-1.053.117-1.1-.1-.849-.016-.129-.307-.849-.615-.483s-1.025.059-1.084.366a4.657,4.657,0,0,1-.366.776,4.623,4.623,0,0,1,.366,2.356c-.044.762-.073,1.616-.044,2.416.014.424.03.82.073,1.2l0,0a5.154,5.154,0,0,0,.322,1.537c.439.981,1.713-.117,2.02.249s.483.981,1.039,1.347a1.741,1.741,0,0,0,.849.366,2.1,2.1,0,0,1-1.1.425c-.542,0,.5,1.332,1.039,2.313a3.579,3.579,0,0,0,2.562,1.464c.734.133.118-1.23.059-1.713s.556-.966.19-1.332-.251-.6.176-.366,1.044.352,2.2-.249-.425-1.333-.908-1.713a8.1,8.1,0,0,1-2.2-3.163c-.557-1.464.427-.615,1.216-.556s1.155-.424.848-.849c-.292-.424,1.348-.615,2.753-.483a1.833,1.833,0,0,1,.951.322l.938-.937.41-.732-.44-1.084h0l1.263-.618.732.278h1.377c-.395-.615-.561-1.064-.161-2.664a7.46,7.46,0,0,1,.731-1.9h0a3.837,3.837,0,0,0,.542-1.332c.119-.926,1.348-1.1,1.773-2.2.067-.19.14-.351.2-.483a4.171,4.171,0,0,0-.658-.52,4.338,4.338,0,0,1,.664.522,12.241,12.241,0,0,1,.776-1.347,5.551,5.551,0,0,1,2.928-2.372c1.333-.381.732.966.908,1.332.146.278,1.317.2,2.108.263l.718-.366,1.83.82a1.537,1.537,0,0,1,.044-.893c.249-.673,2.079-1.1,3.294-1.537a26.633,26.633,0,0,1,3.073-.966,7.086,7.086,0,0,1,1.493-.187c1.466,0,0,.732-.307.922a13.942,13.942,0,0,0-2.137,3.045c-.79,1.4-.249,2.693.542,2.869.6.128,2.109,1.666,3.895,3.1l.005,0a20.791,20.791,0,0,0,1.731,1.232,2.5,2.5,0,0,1,.325.205,2.575,2.575,0,0,1,.541,3.6H405.8l1.44,1.074.024.024v0l-1.462-1.1h-2.635a4.323,4.323,0,0,1-.44.585c-.483.483-5.431.732-7.876-.117a25.171,25.171,0,0,0-6.765-1.654c-1.6,0-2.135.981-3.235,1.83s-3.485.117-4.7-.117a6.73,6.73,0,0,1-1.713-1.464c-.043-.068-.087-.141-.117-.2h-1.391l-.732-.279-1.258.615.439,1.084-.41.732-.937.938c1.347.932.629,3.611.629,4.3,0,.833,1.1,1.229,1.772,3.118.79,2.211,4.48,3.544,6.047,2.9,1.548-.645,2.2-.542,3.748.366s1.828.541,2.928-.279a3.455,3.455,0,0,1,4.026.088.667.667,0,0,1,.22.438h0a7.9,7.9,0,0,1-.6,3.235h0c-.4,1.2-.892,2.443-1.244,3.351h0a9.878,9.878,0,0,0-.4,1.121c-.059.217-.118.451-.206.7l.006,0a3.926,3.926,0,0,1-1.3,2.013c.332,1.452.771,3.458.8,4a.585.585,0,0,0,.131.305l-.248.481.073,2.782c.263,0,.541-.015.849-.044,1.919-.176,4.568,7.7,8.141,13.909,2.3,4.026,4.378,6.822,5.74,9.693l1.293-.437v0l-1.3.439a16.294,16.294,0,0,1,1.5,5.051,2.094,2.094,0,0,0,1.2,1.816c2.971,1.363,10.537-2.928,14.437-4.655a24.194,24.194,0,0,0,3.293-1.816l-2.84-5.623-5.76,1.127.006-.006,5.753-1.128.366-.073,4.583-1.361s2.56-3.481,2.284-4.215l0,0c.277.732-2.285,4.217-2.285,4.217l-4.583,1.361-.366.073,2.84,5.625a48.828,48.828,0,0,0,10.352-9.356c3.381-4.113,1.361-4.934-.645-5.213v0a4.576,4.576,0,0,1-3.66-3.1,9.072,9.072,0,0,0-.439-1l-.117,1.45-1.186-.19-.087,1.11,0,0,.089-1.112,1.185.19.117-1.45,0,0c-.263-.5-.469-.57-.849-.38-.542.277-2.84,3.1-5.856,3.294a3.713,3.713,0,0,1-1.977-.425h0c-1.814-.966-3.015-3.4-4.333-5.681-.692-1.191-1.492-2.254-1.992-3.191h0c-.6-1.11-.758-2.044.265-2.761-.948-.4-2.327-.995-2.548-.629-.175.321-.919,1.5-1.315,2.148h0l-2.458-.209,2.458.208c.4-.644,1.141-1.83,1.317-2.152.22-.371,1.6.229,2.548.629l.132-.087v0a5.073,5.073,0,0,1,1.051-.482c2.811-.967,3.381,2.578,3.47,3.485s4.305,3.015,4.671,3.381c.32.322,4.419.161,6,1.332a1.457,1.457,0,0,1,.5.586c.63,1.41,4.891,1.684,8.668,1.61a20.513,20.513,0,0,1,.659-2.239c.278-.645,1.729-.457,2.285-.733a.414.414,0,0,0,.079-.065.436.436,0,0,1-.08.068c-.541.279-2.005.088-2.284.732a21.042,21.042,0,0,0-.659,2.24c1.2-.014,2.344-.073,3.31-.146,3.219-.21,6.262-1.571,8.367,2.533V157.4l-.489.161v0l.489-.161V145.028l-.028-.007v0l.027.007v-4.571l-.76-.834,0,0,.758.83V135.4l-2.288.072.117-2.02-.6-.849-.674-1.947-.615.059-1.348-1.9-5.607.307s-3.47-3.719-6.281-5.183l-5.006,1.6v0l5.007-1.6c2.812,1.464,6.282,5.184,6.282,5.184l5.607-.308,1.347,1.9.616-.059.673,1.947.6.849-.116,2.02,2.286-.072V42.114a27.637,27.637,0,0,1-4.048-4.017M381.928,35.75l0,0v1.188l0,0Zm-1.377,1.83h0l-.45,1.366h0ZM348.732,74.464l-.007.006s-.147-.093-.236-.037c.089-.065.242.03.243.031m-1.1,5.009h0a.9.9,0,0,0,.3-.229.92.92,0,0,1-.3.23m1.827-16.966,0-.006,2.439.248v.007Zm4.889-10-1.957.73v0l1.957-.731Zm.122-1.468v0a7.851,7.851,0,0,0,1.186-1.315,7.816,7.816,0,0,1-1.186,1.318m1.576-5.486a.209.209,0,0,0-.1.1.218.218,0,0,1,.1-.106c.09-.029.2-.163.316-.345-.122.186-.229.323-.321.352m1.83-1.831a1.014,1.014,0,0,0-.854.495c.253-.312.539-.545.859-.5a1.522,1.522,0,0,0,1.415-.324,1.515,1.515,0,0,1-1.42.33m4.895-1.581-3.539-1.345v-.008l3.542,1.346,0,.007m4.509-.058a7.84,7.84,0,0,1-1.743-1.459,7.83,7.83,0,0,0,1.742,1.458c.254,0,2.46,1.237,2.505,1.644-.057-.4-2.247-1.643-2.5-1.643m2.65,5.3h0a1.4,1.4,0,0,1-.341-.25,1.493,1.493,0,0,0,.341.249m-.278,5.12.15-.489-.15.49Zm2.268-10.978-1.962-1.464a11.791,11.791,0,0,1-2.562.366c-.483-.117-1.332-2.928-1.332-2.928l-1.23.849-.746.352c.064.1.135.2.205.3-.07-.1-.141-.206-.205-.3l-.585.263a1.23,1.23,0,0,0-.175.094,1.16,1.16,0,0,1,.179-.1l.585-.264.747-.352,1.23-.849s.849,2.812,1.333,2.929a11.852,11.852,0,0,0,2.562-.366l1.959,1.462Zm.738-1.714v0a1.419,1.419,0,0,0,.762-.321,1.42,1.42,0,0,1-.763.325m9.263,15.34c-.027-.071-2.106-5.571-2.106-5.851s1.2-1.838,1.288-2.2.732-1.743,0-2.562a6.7,6.7,0,0,0-2.109-1.377l.279-2.825a6.727,6.727,0,0,1,.014-.952l0,.006a7.031,7.031,0,0,1,.352-1.435,6.363,6.363,0,0,0,.2-2.767l-1.332-.5-.5-1.581-1.947.981-.846-.132,0-.006.849.132,1.947-.981.5,1.581,1.332.5a6.353,6.353,0,0,1-.2,2.768,6.941,6.941,0,0,0-.352,1.434l0,0a6.912,6.912,0,0,0-.016.944l-.278,2.826a6.739,6.739,0,0,1,2.109,1.376c.732.82.089,2.193,0,2.563s-1.289,1.923-1.289,2.2,2.109,5.856,2.109,5.856ZM363.988,137.6h0l.775-1.272h0Zm63.88,38.8a12.214,12.214,0,0,1,1.054.673l-.059-1.3.556-1.918h1.1l.006.006h-1.1l-.557,1.917.059,1.3a11.829,11.829,0,0,0-1.054-.673l-3.486-.4Zm12.242-27.948h0l1.838.568h0ZM427.93,108.6l.022.017-.273,1.437-.019-.032Zm-9.862-.176h0l-.1.9h0Zm-.833,12.162-1.81-2.642h-1.743v-.01h1.742l1.816,2.651Zm-5.385,20.358c-.884-.413-1.852-1.216-2.562-1.492.71.275,1.677,1.077,2.562,1.492m-.223-.969-.112-.054-.086-.364.088.363Zm.863-1.006.032.5-.034-.5-.051-.03Zm-1.109-4.029,1,.585-1.009-.584-1.267-.277,0,0Zm-1.63.375,1.17.549,0,0-1.164-.547h0Zm2.129,4.786h0v.855c.009.018.028.021.045.027a.238.238,0,0,1-.048-.024Zm.747.932a1.091,1.091,0,0,1-.448.011,1.1,1.1,0,0,0,.442-.014v0c1.185-.234,2.5-1.874,2.972-1.874h0c-.475.006-1.786,1.639-2.969,1.873m3.882-31.248a9.561,9.561,0,0,1,.347,1.9,9.8,9.8,0,0,0-.352-1.9ZM413.4,111.81l.087,2.278v0l-.089-2.277Zm-.729,4.3,1.1.175-.041.767.04-.757-1.1-.176Zm-.427,17.33-.078-.025h0Zm-3.151-1.875,1.288-.176.107.083-.1-.076-1.281.17-1.1.366,0,0ZM389.382,106.5h.757v0h-.758Zm-5.09-4.388V102.1l1.761.233,0,0Zm2.064-2.081-1.2.3h0l1.2-.3Zm-5.064-6.354.981-.6,0,0-.969.593-.6.307v0Zm-.65-.616-.008-.118h0Zm.08,28.663c-.554-.139-.945-.22-.976-.226.044.008.428.082.976.226m.194-1.46-.087-1.315h0l.089,1.317h0m-.729-1.143h0l.1-1.917h0Zm-15.877,5.127,1.331.556v0l-1.331-.556Zm-2.52,2.019-.422-.349.423.348Zm-1.826-2.665h0a3.476,3.476,0,0,0,1.068-.584h0a3.455,3.455,0,0,1-1.066.584m-3.973,1.993c-.481.058-1.033-.607-1.038-.614v0s.556.674,1.039.615a1.761,1.761,0,0,0,.51-.232,1.754,1.754,0,0,1-.511.233m-7.86-14.83a8.457,8.457,0,0,1,.6.788.369.369,0,0,1,.059.148.365.365,0,0,0-.058-.144,8.524,8.524,0,0,0-.6-.791Zm11.036,3.961v-.981l.615-.234.6-.19.234-.231v.005l-.23.23-.6.19-.616.234v.981h-1.157l-.908.629v0l-.069.042-1.157.059-.005,0,1.153-.059.073-.043.908-.63Zm-3.6,5.733,0,0h0s.7.629,1.214,1.11h0l-.7.29.7-.289c-.511-.479-1.2-1.1-1.214-1.11m.823-.369h0l.044-1.61h0Zm.761-3.471v0l.483.542-.146,1.1h0l.146-1.1Zm-6.759-.423-.615,1.157.189,1.523-.005,0-.19-1.519.616-1.156v-.484h.005Zm1.472-.76-3.44-2.957,0,0,3.439,2.956,0,0Zm1.255.39v-.615l.425-1.1.864.307,0,0-.859-.305-.425,1.1v.615l-.659.117,0,0Zm3.668,5.741h0l0,0a3.277,3.277,0,0,1,.527.571,9.473,9.473,0,0,0,1.926,1.137,9.514,9.514,0,0,1-1.926-1.136,3.207,3.207,0,0,0-.527-.571m3.951-4.641h0l.182.032Zm1.376-.235.069.01-.069-.01-.043.468h0Zm5.4-2.137a1.322,1.322,0,0,0,.512-.307h0a2.574,2.574,0,0,0,.218-.159l-.322-1.1,1.83-2.518h0l-1.829,2.517.322,1.1a2.608,2.608,0,0,1-.219.16,1.33,1.33,0,0,1-.513.309c-.176,0-.587,1.3-.645,1.493v0h0c.06-.2.469-1.493.645-1.493m10.8-8.128,0,0-.788.919,0,0Zm-9.627,23.428-.5-.305-1.083-.659h0l1.079.656.5.307Zm.17-24.949.79.555h0Zm.864,2.443a14.45,14.45,0,0,1,2.122-1.522h0a14.382,14.382,0,0,0-2.122,1.523l.573.425-.132.542.542.146-.089,1.963h-.005l.089-1.961-.542-.146.132-.542-.572-.425Zm-3.341,11.97a9.359,9.359,0,0,1-.888,2.243,9.7,9.7,0,0,0,.888-2.243m2,8.4h0l-.537-.175h0Zm7.146-11.318h0c-.017.031-.043.054-.062.084.019-.03.045-.053.062-.084m-11.612-.322.4-.381h0Zm1.68,9.02-.141.849.774.673.5.146.921-.644.28.278h0l-.278-.277-.922.644-.5-.146-.776-.673Zm11.764-9.136h0a3.882,3.882,0,0,0,1.141.966h0a3.851,3.851,0,0,1-1.141-.965m1.943-8.437.73-.906,0,.005-.729.9Zm.177-14.45h0l-.725-.4Zm-1.385-3.236.2,2.578h0l0,0-.2-2.573Zm.165,2.563h0l-.8.761Zm-3.1-4.583.864-.5v0l-.863.5-.314-.292Zm-1.419,4.453,1.581,1.611-1.58-1.609-1.464-.147h0Zm-5.226,5.946,1.08,1.445h0l-1.081-1.446Zm-.41-2.344.279.878-.41.5.087.949h0l-.087-.95.41-.5-.279-.877Zm-4,17.7a.841.841,0,0,0,.981-.19l.908-.059,0,0-.907.059a.841.841,0,0,1-.981.19c-.483-.307-1.64.366-1.64.366l0,0c.015-.009,1.157-.67,1.637-.365m-2.255-.864,0,0-1.212.438v0Zm-3.464-1.79a.7.7,0,0,0-.154-.431.672.672,0,0,1,.154.431m-.447-.524h0c-.473.055-.768,1.132-1.039,1.117.269.007.554-1.066,1.038-1.117m-5.183-9.15-.537-.247h0l.537.247Zm-4.83,16.981-.343.226h0Zm-3.028.287h0v.788h0Zm-4.025-4.089-1.1,2.08-.189,2.19.189-2.192Zm-2.139-.118-.366-.556-.771-.546.773.547.366.555Zm5.241,5.975h0l-.365-.482h0Zm-.831-1.636.1,1.153h0l-.1-1.153Zm-.018-.249.007.128-.009-.128Zm-4.816-14.705.542-.117.059-.54-.059.542-.542.117Zm.117,1.83v0l-1.946.848h0Zm-1.156,1.642-.421.686.42-.687Zm-1.1,2.021.19-.922-.439-.483-.791-.19-1.637-.234,1.64.233.791.191.439.482-.19.923.789.584v0Zm.924,2.136.012-.011-.01.012.542.849-.22.908h0l.22-.907Zm-.5,10.912,0-.012,1.646-.787,0,.009Zm2.076,2.193-.554-1.081,0,0,.554,1.079Zm1.587-1.586-1.7.117,0,0v0l1.7-.117,1.039-1.347,0,0Zm2.078.253,0-.006.423-1.517.005,0Zm1.772-.923-.006,0,.234-1.023h.006Zm.851-1.64-.117.615h-.006l.117-.615.22-.014-.278-.233h0l.278.233Zm3.6-.672h0v.98h0Zm2.313,1.406h0a17.644,17.644,0,0,0,1.945.234h0a17.157,17.157,0,0,1-1.944-.234m1.819,2.9h0l.13-.467h0Zm1.743-.965-.41,1.009h0l.41-1.009.41-.044-.044-.864.459-.147-.455.146.043.865Zm5.166,1.963-.849-.176h0l.849.176,1.523.556h0Zm3.981-2.87a14.827,14.827,0,0,0-1.786.132s-.351.292-.76.584c.41-.293.762-.586.762-.586a14.81,14.81,0,0,1,1.785-.132l.688.864.006.157-.006-.155Zm4.715,12.663-.146.059h0l.175-1.917-.673-.117v-.424l-.317-.029v0l.32.03v.425l.673.117L368.148,135l.146-.059.43-.167Zm5.49-.176h-1.288l-.951-.322-1.741-.088,1.743.087.952.322h1.285Zm.456-.645h0l.664-.334Zm4.3-9.838-.074-.614,1.215-.761.044-1.421h.006l-.044,1.42-1.215.762.074.615a1,1,0,0,0,.537.458,1,1,0,0,1-.543-.46m2.6-2.485c.45-.013.418-.588.418-.984h0a.44.44,0,0,0-.028-.158.443.443,0,0,1,.029.16c0,.4.034.976-.423.983m-.2-14.4-.659-.059h0l.654.059.922-.425,0,0Zm1.772-1.04-.059,1.464-.005-.005.059-1.46.615-.791,1.509-.058h0l-1.5.058Zm3.364-.879-.014-.834.019,0,.014.83Zm1.659-.645-.556.322,0-.007.54-.313.908-.41,0,.005Zm3.665,4.027h0l.348-.042Zm.864,1.831-.005-.011.675-.632.008.008Zm1.933.234-.008,0a5.342,5.342,0,0,0,1.394-.641l0,.007a5.344,5.344,0,0,1-1.389.636m2.528.865a5.635,5.635,0,0,1,.732-.453l.006,0a5.867,5.867,0,0,0-.72.446c-.005,0-.012,0-.018,0m3.253,5.771a9.586,9.586,0,0,0-1.5.068,9.342,9.342,0,0,1,1.521-.071.752.752,0,0,0,.189-.023.725.725,0,0,1-.205.026m5.275,12.446-1.549.085-2.477-.817-.506.2.5-.2,2.475.819,1.551-.087,2.2,1.377.161.161-.158-.154Zm1.925,7.772,1.183.366,1.2.451.093.044-.09-.042-.278.847h0l.278-.845-1.2-.453-1.185-.367Zm-4.372,11.889a3.635,3.635,0,0,0,.065-.718,13.017,13.017,0,0,1,.058-1.524,13.285,13.285,0,0,0-.057,1.522,3.66,3.66,0,0,1-.066.72m3.24-5.359h0q-1.059.173-2.105.418,1.046-.246,2.107-.419m-10.391,1.888a4.247,4.247,0,0,1,3.191-.176c.732.352,1.831-.556,3.016-.732.616-.189,1.239-.353,1.865-.5-.627.151-1.25.315-1.866.5-1.186.176-2.284,1.084-3.016.732a4.237,4.237,0,0,0-3.191.176l-1.463-.645Zm-1.114,1.1h0l-.365.039Zm-1.042,5.638a3.076,3.076,0,0,0-.788,1.185.978.978,0,0,0,.145,1.093.977.977,0,0,1-.146-1.094h0a3.073,3.073,0,0,1,.788-1.184m2.964,7.431c.166-.807-1.135-1.784-1.54-2.146-.211-.183-.227-.352-.069-.506-.15.152-.132.318.07.5.407.364,1.714,1.346,1.539,2.154m2.544-3.511h0M413.4,187.2l.555.555-.007.006-.557-.556-6.669-.555v-.006Zm-3.384-40.173-.557-1.917h0l-.453-1.55-.454-1.185a6.386,6.386,0,0,1-.184-2.674,6.4,6.4,0,0,0,.186,2.67l.453,1.186.454,1.551.556,1.918.366.644,1.653.352-1.653-.35Zm21.513-4.648-.732.629h-1.567l-1.464,1.465-.966.1a1.84,1.84,0,0,1-.834,1.523c-1.155.6-4.818-.5-6.955-1.83-1.2-.765-1.537-1.336-1.508-2.2l-.006,0c.03-.645.263-1.479.47-2.693a6.9,6.9,0,0,0-1.377-5.534l-.007.007a3.181,3.181,0,0,0-.5-.547c-1.1-.981-1.216-2.739-1.274-4.086s-.923-2.386-.923-3.177,2.754-2.809,4.159-3.909l.029-.03-2.108-1.317.013,0,2.1,1.31a6.693,6.693,0,0,1,6.135-1.318,3.643,3.643,0,0,1,.849,1.464,2.585,2.585,0,0,1-.732,1.771,5.572,5.572,0,0,1-2.313.556c-.733.117-.381,1.83-1.172,1.581-.791-.233-.908.309-.542.791.366.5,1.039,2.81,1.581,3,.557.176,2.021,1.215,2.08,1.64.043.308-.1,1.582.322,1.962l.015-.01c.175.15.43.161.82-.082,1.4-.849,2.082.732,2.562,1.83s-.312,1.288-2.2,1.039-1.274,1.157-.849,1.713a15.769,15.769,0,0,1,1.831,3.66,7.008,7.008,0,0,1,.336,2.871l.966-.1,1.464-1.464h1.562l.731-.629.908-.1.009.018Zm4.392,1.467-1.2-.469-1.918-.366-.009-.018,1.917.366,1.2.469.82.176,0,.017Zm1.727,1.276h-.732l0-.018h.726l.819,1.01,1.567.176v.018l-1.559-.175Zm1.83,12.725v-.017l1.561.263v.016Zm2.2,6.764-.009-.013h1.377v.013Zm7.765-3.76-1.727,1.288a33.358,33.358,0,0,1-4.392.454,10.823,10.823,0,0,1-3.689-1.01l-.051-.076,0,0,.049.073a10.83,10.83,0,0,0,3.69,1.011,33.529,33.529,0,0,0,4.392-.454l1.725-1.286Zm2.578-2.472-1.377.1-.922.542v-.005l.923-.542,1.376-.1Zm-1.65-14.3v.436l-1.889-.444-.117.922h-1.6l-.117,1.771-2.753,1.274-.116,1.274-1.524.249h0l1.522-.249.117-1.274,2.752-1.274.117-1.771h1.6l.117-.922,1.889.439v-.439a1.574,1.574,0,0,0-.03-.31,1.512,1.512,0,0,1,.032.319m-8.061-6.248a6.488,6.488,0,0,1-.53-1.485,6.66,6.66,0,0,0,.53,1.485M430.8,109.237a6.916,6.916,0,0,0-.732,1.011l-.012-.01a6.894,6.894,0,0,1,.717-.99,4.266,4.266,0,0,1,1.464-.922h0a4.28,4.28,0,0,0-1.439.91m2.464-.087-.015-.012.457-.812.021,0Zm3.851.907-.014-.009.617-.991.015.007Zm3.357-.441c.652-.366.093-1.826-.455-2.374a4.362,4.362,0,0,0-1.743-.922s-.457-.631.366-1.186,1.01-.731.923-1.2a5.106,5.106,0,0,1,.176-1.551l.023,0a5.114,5.114,0,0,0-.173,1.538c.088.468-.1.659-.922,1.2s-.366,1.186-.366,1.186a4.377,4.377,0,0,1,1.742.922c.556.555,1.118,2.042.429,2.385m1.433-7.06-1.8-.9.454-.645-1.187-.542.732-1.274.019,0-.723,1.259,1.185.541-.453.645,1.83.922Zm5.915-4.5-.026,0,.175-1.076.026,0Z",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48792",
    "data-name": "Group 48792",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48791",
    "data-name": "Group 48791"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48790",
    "data-name": "Group 48790"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52354",
    "data-name": "Path 52354",
    d: "M386.936,123.877c-.133.19,1.464.981,1.756,2.313s.978.615,1.9.19a6.607,6.607,0,0,1,2.869-.922c.907.073.351-.732.234-1.039l.005,0c-.118-.293-1.523-.234-2.255-.293a1,1,0,0,1-.776-.937l-1.83-.821-.718.366a1.786,1.786,0,0,1,.571.1c.616.248-1.639.849-1.756,1.039",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48795",
    "data-name": "Group 48795",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48794",
    "data-name": "Group 48794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48793",
    "data-name": "Group 48793"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52355",
    "data-name": "Path 52355",
    d: "M389.831,148.717a5.3,5.3,0,0,1-.615.366,2.046,2.046,0,0,1-.586.1l-1.391.088c-.4.029-.834.1-1.01.439a.753.753,0,0,0,.336.952,2.043,2.043,0,0,0,1.069.219,1.537,1.537,0,0,0,.585-.1,2.174,2.174,0,0,0,.264-.133c.526-.354,1.039-.72,1.551-1.1a1.731,1.731,0,0,0,.41-.4.557.557,0,0,0,.059-.542v.011a.745.745,0,0,0-.673.1",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48798",
    "data-name": "Group 48798",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48797",
    "data-name": "Group 48797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48796",
    "data-name": "Group 48796"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52356",
    "data-name": "Path 52356",
    d: "M374.325,150.218a.9.9,0,0,0,.468-.132.382.382,0,0,0,.161-.425h0c-.073-.163-.277-.22-.453-.263-.278-.047-.541-.1-.82-.147-.469-.088-.952-.191-1.42-.278a4.847,4.847,0,0,0-2.24-.074.575.575,0,0,0-.161.089.244.244,0,0,0,.014.279.587.587,0,0,0,.25.175,7.952,7.952,0,0,0,4.2.776",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48801",
    "data-name": "Group 48801",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48800",
    "data-name": "Group 48800"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48799",
    "data-name": "Group 48799"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52357",
    "data-name": "Path 52357",
    d: "M356.783,121.563h0Z",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48804",
    "data-name": "Group 48804",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48803",
    "data-name": "Group 48803"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48802",
    "data-name": "Group 48802"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52358",
    "data-name": "Path 52358",
    d: "M346.531,94.955a.364.364,0,0,0,.249.117c.674.059,1.158.485,1.158.791s-.25.982-.6.806c-.382-.193-.865-.133-.615.307.233.425.539.849,1.039.542a2.285,2.285,0,0,0,1.1-1.89,3.57,3.57,0,0,1,.176-1.771c.171-.273.732-.141.571-.8l0,0c-.014-.058-.044-.146-.073-.234-.38-.908-.556-1.157-1.113-1.157a1.388,1.388,0,0,0-.907.366,1.693,1.693,0,0,0-.982,1.64c.161.41-.219,1.039,0,1.288",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48807",
    "data-name": "Group 48807",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48806",
    "data-name": "Group 48806"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48805",
    "data-name": "Group 48805"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52359",
    "data-name": "Path 52359",
    d: "M342.156,88.973a2.517,2.517,0,0,0-1.318,1.727,10.352,10.352,0,0,0,0,3.163c.044.5.82,1.008.952,1.508a9.846,9.846,0,0,1,.176,1.171l2.182.161a2.793,2.793,0,0,1-.117-.586c0-.307-.307-1.332-.059-1.332s.425.47.673,1.084,1.288.075,1.4-.425a.607.607,0,0,0-.014-.322h0c-.1-.425-.542-.835-.776-.835-.307,0-.922.364-.922.059s1.1-.9,1.347-1.4a9.325,9.325,0,0,0,.5-1.464,8.866,8.866,0,0,1-1.23-1.142c-.277-.264.5-1.963.455-3.017s-2.563,1.23-3.251,1.655",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48810",
    "data-name": "Group 48810",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48809",
    "data-name": "Group 48809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48808",
    "data-name": "Group 48808"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52360",
    "data-name": "Path 52360",
    d: "M354.7,142.995a.817.817,0,0,0,.132-.249c.03-.113-.029-.214-.322-.2v0c-.586.044-1.508.409-2.24.453s-1.712-.425-2.283-.366c-1.29.147-1.1.6-1.1.6a.92.92,0,0,0,.483.82,4.077,4.077,0,0,0,.748.278,13.516,13.516,0,0,1,2.752,1.318c.322.279,1.319.469,1.406,0,.1-.453-.131-.864-.043-1.464a4.029,4.029,0,0,1,.468-1.187",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48813",
    "data-name": "Group 48813",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48812",
    "data-name": "Group 48812"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48811",
    "data-name": "Group 48811"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52361",
    "data-name": "Path 52361",
    d: "M342.7,134.638a.744.744,0,0,0,.176-.029c.5-.114.864-1.83.864-2.314a.591.591,0,0,0-.117-.336,1.847,1.847,0,0,0-.615-.513q-.047.009-.093.021a1.582,1.582,0,0,0-1.137,1.927c.222.849.522,1.244.922,1.244",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48816",
    "data-name": "Group 48816",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48815",
    "data-name": "Group 48815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48814",
    "data-name": "Group 48814"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52362",
    "data-name": "Path 52362",
    d: "M341.293,136.44a8.829,8.829,0,0,0,.249,3.543,1.391,1.391,0,0,0,1.112.776c.352,0,.673-.234.836-.893,1.215-5.124-.615-4.524-.615-4.524h0a.682.682,0,0,0-.163.014c-.467.084-1.32.439-1.42,1.084",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48819",
    "data-name": "Group 48819",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48818",
    "data-name": "Group 48818"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48817",
    "data-name": "Group 48817"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52363",
    "data-name": "Path 52363",
    d: "M331.761,132.076v.013h0Z",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48822",
    "data-name": "Group 48822",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48821",
    "data-name": "Group 48821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48820",
    "data-name": "Group 48820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52364",
    "data-name": "Path 52364",
    d: "M328.937,132.133a5.281,5.281,0,0,1-1.141-.732l-1.743.087-2.782-.776s-.893-.805-1.434-1.42a1.181,1.181,0,0,1-.586.322c-.732.044-6.956-.322-8.873-.556a3.973,3.973,0,0,0-3.895,1.421c-.5.864.233,1.1.556,1.464a2.884,2.884,0,0,1,.233,1.17l-.005,0c.059.83.076,1.874.176,2.43.176.908-1.1,3.881-1.508,4.569s.453,2.328.776,3.66,1.1,1.42,1.7,1.244a2.918,2.918,0,0,1,1.024-.073,14.788,14.788,0,0,1,.206-2.152,8.244,8.244,0,0,0,.117-1.6.5.5,0,0,0,.308-.589h0a.5.5,0,0,1-.307.6,8.244,8.244,0,0,1-.117,1.6,14.649,14.649,0,0,0-.206,2.152,2.964,2.964,0,0,1,2.27,1.3,3.059,3.059,0,0,0,1.068,1.128c.469.279.879.22,1.025-.073.279-.5,2.065-1.1,3.939-1.187s2.43-.688,4.392-2.518c1.979-1.83,1.51-3.016,1.1-3.485-.409-.453.277-1.83,1.377-3.294a3.3,3.3,0,0,1,2.782-1.6c.732-.049,2.109-1.6,2.109-1.6.347-.35.293-.872.264-1.539q-1.411.093-2.825.044m-15.943,1.935h-.008l.115-.718h.008Zm-2.878-.308-.187-.894h0l.187.895Zm1.89,6.044h0a2.111,2.111,0,0,0-.008.4,2.118,2.118,0,0,1,.007-.4m.735-4.318-.366,3.411-1.091.174-.01-.01,1.1-.176.366-3.411,1.091-1.336h.01Z",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48825",
    "data-name": "Group 48825",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48824",
    "data-name": "Group 48824"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48823",
    "data-name": "Group 48823"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52365",
    "data-name": "Path 52365",
    d: "M330.034,138.752c-.368.368.351,1.1,1.332,1.1s.615-1.479,0-1.611v0a1.964,1.964,0,0,0-1.332.513",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48828",
    "data-name": "Group 48828",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48827",
    "data-name": "Group 48827"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48826",
    "data-name": "Group 48826"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52366",
    "data-name": "Path 52366",
    d: "M307.5,107.289c2.2-.25,4.261-2.329,5.242-2.329s1.523-2.738,1.274-4.817a1.549,1.549,0,0,1,.073-.775c.41-1.025,1.977-.6.234-3.31h0a1.91,1.91,0,0,0-1.962-.673l-.718,1.288-.908.908-.073.732.73.671,0,0-.732-.673.073-.732.908-.908.718-1.288a6.771,6.771,0,0,0-1.421.307.831.831,0,0,0-.084.029,1.03,1.03,0,0,0-.589,1.332c.19.528.19,1.011-1.069,1.084-2.061.117-2.852-.19-2.5.542a10.175,10.175,0,0,1,.673,4.085c-.117,1.1-2.068,4.758.132,4.525m4.934-9.342.615,1.288h0l-.614-1.285Z",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48831",
    "data-name": "Group 48831",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48830",
    "data-name": "Group 48830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48829",
    "data-name": "Group 48829"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52367",
    "data-name": "Path 52367",
    d: "M314.2,84.755h0Z",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48834",
    "data-name": "Group 48834",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48833",
    "data-name": "Group 48833"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48832",
    "data-name": "Group 48832"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52369",
    "data-name": "Path 52369",
    d: "M313.284,86.586a.482.482,0,0,0,.352-.059.366.366,0,0,0,.1-.176,7.779,7.779,0,0,1,.323-1.171.685.685,0,0,0,.146-.424c-.045-.2-.312-.248-.512-.248a1.585,1.585,0,0,0-.527.044,1.049,1.049,0,0,0-.586.585,2.1,2.1,0,0,0-.117.849,1.081,1.081,0,0,0,.016.22c.105.293.483.366.8.38",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48837",
    "data-name": "Group 48837",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48836",
    "data-name": "Group 48836"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48835",
    "data-name": "Group 48835"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52370",
    "data-name": "Path 52370",
    d: "M311.873,88.459a.474.474,0,0,0,.175-.234c.121-.252.429-.659.4-.952h0a.864.864,0,0,0-.439-.4c-.293-.088-.455.205-.542.351a1.213,1.213,0,0,0,0,1.055.337.337,0,0,0,.41.176",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48840",
    "data-name": "Group 48840",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48839",
    "data-name": "Group 48839"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48838",
    "data-name": "Group 48838"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52371",
    "data-name": "Path 52371",
    d: "M284.918,28.7c.422-6.563,1.823-17.289,2.436-28.424h-71.7c.484,1.115.994,2.4,1.542,3.9,5.49,15.008,9.883,18.3,9.883,25.257s-4.761,17.2-2.563,23.793,13.545,28.185,17.571,25.989,6.223-17.205,10.249-20.865,7.686-12.079,15.007-13.909,16.84-4.391,17.57-15.739",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48843",
    "data-name": "Group 48843",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48842",
    "data-name": "Group 48842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48841",
    "data-name": "Group 48841"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52372",
    "data-name": "Path 52372",
    d: "M300.179,57.136v0l0,.009Z",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48846",
    "data-name": "Group 48846",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48845",
    "data-name": "Group 48845"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48844",
    "data-name": "Group 48844"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52373",
    "data-name": "Path 52373",
    d: "M300.178,57.139a23.856,23.856,0,0,0-2.2-4.017,13.407,13.407,0,0,0-2.812-1.962c-.848-.6-1.58.981-1.58,2.079s-1,.254-1.963-.366-1.7-.483-2.678.981-.352.733-.85-.249-.995.121-1.23,1.83-1.7-.984-1.947-2.2a2.108,2.108,0,0,0-2.442-1.365,10.548,10.548,0,0,0-2.429,3.427c-.982,1.831.354,1.464.965,1.464s2.329-.381,2.812.234-1.214,1.23-3.178,1.464c-1.947.252.865,1.1,2.33,1.1s1.214,1.468,1.214,2.2-1.464,1.348-1.58,1.963c-.134.6,2.925.116,4.025.366s2.435,1.2,3.778,1.7,4.87-3.293,7.2-4.393c2.312-1.1,2.313-2.676,2.562-4.256",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48849",
    "data-name": "Group 48849",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48848",
    "data-name": "Group 48848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48847",
    "data-name": "Group 48847"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52374",
    "data-name": "Path 52374",
    d: "M249.791,225.639c-2.621-.059-9.139-2.812-13.295-4.276s-4.641-4.393-5.856-7.555a5.3,5.3,0,0,0-1.727-2.065l-2.006,4.188-2.65.19,0,0,2.646-.19,2.006-4.188h0a22.378,22.378,0,0,0-4.523-2.678v0l0,0a34.8,34.8,0,0,0-5.8-2.137l-.279,3.338-1.344.711,1.34-.712.278-3.338a7.39,7.39,0,0,0-.892-.206c-1.084-.174-2.577-1.2-4.26-2.355h0c-2.87-1.976-6.325-4.348-9.4-3.733-4.876.966-6.337-.981-8.537-1.963a14.8,14.8,0,0,0-4.348-.717l-1.67,1.786s-.819,1.452-1.185,2.285a.442.442,0,0,0,.03.461.433.433,0,0,1-.033-.463c.366-.821,1.185-2.285,1.185-2.285l1.67-1.786c-.176-.015-.352-.015-.542-.015-2.928,0-5.125,2.7-6.34,3.91s-4.875,4.143-4.392,7.569c.41,2.855-1.228,5.886-2.928,7.511,1.068.629,2.958,1.815,3.045,2.24a.39.39,0,0,0,.061.116.377.377,0,0,1-.056-.1c-.088-.424-1.977-1.61-3.045-2.24a6.446,6.446,0,0,1-.982.776c-1.727,1.1-2.313,4.889-2.4,6.734l0,0a4.407,4.407,0,0,0-.03.586c0,1.469-.249,6.105,1.465,7.569s5.359,13.661,14.393,19.035a8.1,8.1,0,0,1,3.148,3.7l1.361-.293.979-1.213,0,0-.981,1.214-1.361.293c2.738,6,1.318,16.617-.645,25.387h-.006c-.922,4.115-1.961,7.8-2.753,10.44-2.518,8.4-4.495,26.384-4.67,37.145h.005c-.043,1.741-.029,3.293.044,4.581.455,8.8,11.7,12.328,16.809,12.241-.109-.066-.224-.12-.335-.182.111.062.226.116.335.182a6.447,6.447,0,0,0,.761-.043c4.627-.483-3.543-4.144-3.908-6.955h0a10.143,10.143,0,0,0-.733-2.313c-.981-2.489-2.048-5.431,2.929-10.248,4.026-3.9.249-4.026-.982-6.705-1.215-2.694,2.695-3.057,3.91-5.257.791-1.42.732-6.661.732-8.052,0-1.1,5.373,1.229,5.241-4.262-.059-2.9,6-1.479,8.419-3.543,4.275-3.66-2.577-7.364-1.332-9.034a.156.156,0,0,1,.146-.059l-.081-.162.082.162c.94-.044,5.5,2.256,7.54.556a16.618,16.618,0,0,0,1.64-1.61l-.425-3.148-3.656-3.289h0l3.661,3.294.425,3.148a77.748,77.748,0,0,0,7.144-9.868c2.928-4.628-1.156-10.015,7.922-11.948,9.766-2.077,9.882-6.106,11.347-13.177s-.4-6.984,7.569-15.373c4.51-4.763-4.143-11.483-9.883-11.6m-26.835,45.868-1.962,1.464-1.581.864,1.575-.862,1.962-1.464-.132-1.7.006,0Zm-36.132-37.57.969-1.233Zm2.563-4.642c.732-.615,4.392-1.347,4.392-1.347l.613-.482h0l-.615.483s-3.659.732-4.392,1.347l0,0m3.407-2.313.981-1.961-.98,1.961Zm5.263,37.206,1.23-.1-1.23.1Zm-.739-23.176-2.028-.117v0l2.025.117,3.661-2.562h2.2v0h-2.2Zm6.093,1.581v0l1.346.732,2.2.366,2.679,1.83,2.446.366v0l-2.444-.366-2.679-1.831-2.2-.366Zm1.569-25.09a.4.4,0,0,0,.144-.2.5.5,0,0,1,.1-.191.519.519,0,0,0-.1.189.4.4,0,0,1-.147.2m7.468,32.043h0l-.614-.482h0Zm4.3,8.493c-.013.207-.02.385-.024.522,0-.137.011-.315.024-.522m7.042,8.6h0l-.043.708Zm-2.079-.253.249-1.943Zm-4.876-3.66-.116-3.895h0l.117,3.9Zm-.847-10.116h0l1.136,1.227Zm0-1.464-3.425.117v0l3.425-.117Zm.57-39.959h0l2.885,5.285,1.142-.161.278-.732h2.37l0,0h-2.368l-.278.732-1.142.161-2.695.38-1.288,1.011-.006,0,1.286-1.009,2.694-.38Zm-8.141,1.185,1.464-.278s1.64-.455,1.64-.908a2.868,2.868,0,0,0-.117-.849h0l1.579.293-1.572-.291a2.872,2.872,0,0,1,.116.849c0,.454-1.64.908-1.64.908l-1.464.278-1.1.63h-.005Zm-4.753-.276,1.65,1.737.176,1.552.908-.19.469.644,0,0-.469-.643-.908.19-.176-1.552-1.654-1.742Zm-4.485,1.827-.835.732.77.94-.772-.941.835-.732-1.011-1.83.366-2.475.454-1.01h0l-.454,1.011-.366,2.475Zm-3.575-5.038h0l-1.915-1.917Zm-5.59-2.288a3.841,3.841,0,0,1-.545-2l.088-1.652h0l-.089,1.654a3.847,3.847,0,0,0,.543,2m-7.1,13.065a1.094,1.094,0,0,1,.966.645h0l0,.007v0a1.1,1.1,0,0,0-.966-.645c-1.29-.118-2.475.06-2.829-.317.362.366,1.544.191,2.824.306m-8.532,5.134h0l.732,1.83L175,228.569h0l.117-1.947Zm20.614,54.9-.233-4.392h0l.234,4.389-1.464,1.215.132,3.411.966,1.713s-.046.606-.165,1.413c.116-.806.16-1.412.16-1.412l-.966-1.713-.137-3.41h.006Zm-6.463,45.987c.483-.367.6-2.561,1.332-4.261a20.6,20.6,0,0,0,.981-2.694l.615-3.045-.366-1.215.6-1.1-.849-.732.483-1.83-.966-.732-.732-2.079,1.215-.615s.368-7.556,1.1-8.17.013-2.8-.117-4.509.834-2.45,1.7-3.909a4.158,4.158,0,0,0,.274-.571,4.32,4.32,0,0,1-.269.57c-.851,1.464-1.817,2.211-1.7,3.909s.851,3.895.117,4.509-1.1,8.17-1.1,8.17l-1.215.615.732,2.079.966.732-.483,1.83.849.732-.6,1.1.366,1.215-.615,3.046a20.593,20.593,0,0,1-.981,2.694c-.732,1.7-.849,3.9-1.332,4.261a6.014,6.014,0,0,0-.527,2.663H188a6,6,0,0,1,.527-2.663m8.663-53.443-1.581,2.928h0l1.579-2.924-.117-3.164.249-1.464,0,0-.249,1.464Zm2.328-8.171-.249,2.445,0,0,.249-2.445h0l1.7-1.829h0Zm5.363.116,0-.006.729-1.937h.005Zm12.925,14.837-.157.495h-.009Zm2.686,1.887-1.458-1.458h0l1.459,1.459Zm4.031-7.433-3.537,1.583-3.161,3.907,0-.007,3.162-3.91,3.534-1.577Z",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48852",
    "data-name": "Group 48852",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48851",
    "data-name": "Group 48851"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48850",
    "data-name": "Group 48850"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52375",
    "data-name": "Path 52375",
    d: "M216.681,332.592a21.216,21.216,0,0,1-3.045.117l-.014.044h0a2.373,2.373,0,0,0-1.771.41c-.732.526-.234,1.113-.044,2.006,1.83.191,2.108.556,3.85-.264.582-.292,2.972-.716,2.782-1.331a1.7,1.7,0,0,0-1.757-.982",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48855",
    "data-name": "Group 48855",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48854",
    "data-name": "Group 48854"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48853",
    "data-name": "Group 48853"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52376",
    "data-name": "Path 52376",
    d: "M201.479,184.582a2.934,2.934,0,0,0-2.328.176.429.429,0,0,0-.263.263c-.058.22.205.4.425.469a2.439,2.439,0,0,0,1.859.161c.571-.265.893-.7.337-1.011Z",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48858",
    "data-name": "Group 48858",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48857",
    "data-name": "Group 48857"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48856",
    "data-name": "Group 48856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52377",
    "data-name": "Path 52377",
    d: "M197.5,184.9c.162-.045.352-.118.4-.278.044-.191-.161-.354-.322-.454v0a19.629,19.629,0,0,0-6.413-2.2l.117,3.777a31.929,31.929,0,0,0,6.223-.849",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48861",
    "data-name": "Group 48861",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48860",
    "data-name": "Group 48860"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48859",
    "data-name": "Group 48859"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52378",
    "data-name": "Path 52378",
    d: "M181.509,204.215h0l0,0Z",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48864",
    "data-name": "Group 48864",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48863",
    "data-name": "Group 48863"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48862",
    "data-name": "Group 48862"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52379",
    "data-name": "Path 52379",
    d: "M175.477,204.683a3.112,3.112,0,0,1,2.474-.82c1.64.089.908,1.816,1.831,3.28l1.726-2.927c-.019-.018-2.556-2.457-5.122-1.814-2.344.586-3.866.631-5.579-.234l-.718,1.9a25.857,25.857,0,0,1,3.367,2.166c2.387,1.83,2.021-1.551,2.021-1.551",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48867",
    "data-name": "Group 48867",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48866",
    "data-name": "Group 48866"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48865",
    "data-name": "Group 48865"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52380",
    "data-name": "Path 52380",
    d: "M191.274,185.752l-.117-3.777a17.406,17.406,0,0,0-2.313-.22l0-.1c-.337-.278-.907.044-.966.483a1.054,1.054,0,0,0,.659,1.025,3.023,3.023,0,0,0,1.3.161c.293.453-.192,1.068-.732,1.185s-1.1-.038-1.64.03-1.113.556-.937,1.068a30.309,30.309,0,0,0,4.744.147",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48870",
    "data-name": "Group 48870",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48869",
    "data-name": "Group 48869"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48868",
    "data-name": "Group 48868"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52381",
    "data-name": "Path 52381",
    d: "M186.283,182.313a.738.738,0,0,0,.307-.938h0a1.1,1.1,0,0,0-.352-.336c-1.508-1.025-3-2.05-4.495-3.075-1.391-.938-2.9-1.919-4.554-1.86a5.813,5.813,0,0,1-1.889.03c-1.011-.293-1.685-1.493-2.724-1.479-.966.016-1.6,1.041-2.489,1.377-.557.207-1.185.131-1.742.307s-1.069.805-.776,1.318c.41.7,1.45.132,2.225-.147a4.245,4.245,0,0,1,3.383.572,10.75,10.75,0,0,0,3.207,1.464c1.127.19,2.533,0,3.162.952.293.454.322,1.054.688,1.42a1.922,1.922,0,0,0,1.128.453,18.877,18.877,0,0,0,3.866.206,2.025,2.025,0,0,0,1.054-.263",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48873",
    "data-name": "Group 48873",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48872",
    "data-name": "Group 48872"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48871",
    "data-name": "Group 48871"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52382",
    "data-name": "Path 52382",
    d: "M178.771,185.108l-.029.279a3.165,3.165,0,0,0,3.28.746,1.828,1.828,0,0,0-3.251-1.025",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48876",
    "data-name": "Group 48876",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48875",
    "data-name": "Group 48875"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48874",
    "data-name": "Group 48874"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52383",
    "data-name": "Path 52383",
    d: "M170.811,202.162c-.146-.073-.307-.145-.453-.234a2.825,2.825,0,0,1-1.435-2.591l-1.079.532,1.07-.528a26.269,26.269,0,0,1,.425-4.451,7.677,7.677,0,0,0-.029-3.134l-.451.137.453-.138a3.18,3.18,0,0,0-1.977-1.991c-1.376-.732-4.948.19-6.325.19a.926.926,0,0,1-.688-.219c-.469-.469-.176-1.612-.044-3.09a6.66,6.66,0,0,1,.337-1.4l-1.241-.233h0l1.245.234c.64-1.9,1.987-4.337,2.5-5.637.644-1.642-3.294-.542-5.213-.542l.006.006c-1.919,0-1.553,1.085-1.553,2.46s-1.834,2.3-3.4,3.308c-1.553.995-5.4.352-7.043-.556s-2.655-4.95-3.3-6.677c-.644-1.743.279-6.677.732-7.409a.639.639,0,0,0,.088-.38l-3.1-.659-5.125-7.819h-1.7a7.046,7.046,0,0,1-1.578,1.958.448.448,0,0,1-.173.075c-.876.216-2.315-2.2-2.769-3a8.693,8.693,0,0,0-2.079-1.962l-.966-1.215-3.529-.116.248,1.209h-.015v.006l-6.471-.615L110.073,155l-4.231.512c1.947,2.317,5.138,8.4,5.387,8.917.279.541-1.467.644-1.64,1.185s2.476,2.665,4.027,2.841,1.917,3.559,4.758,6.311,2.108,0,1.377-.732-6.223-9.795-8.331-13.456.556-4.014,2.108-1.361,12.724,16.56,14.085,18.653c1.377,2.113-1.743,2.108,1.83,6.413s16.107,5.681,18.127,5.037c1.625-.527,3.367,1.713,5.081,3.25l.249-1.7h0l-.248,1.7a7.765,7.765,0,0,0,1.23.951,8.528,8.528,0,0,0,2.357.879h0c1.638.424,3.481.643,4.535.906h0a2.84,2.84,0,0,1,.7.234,1.992,1.992,0,0,1,.717,1.371v.005a1.371,1.371,0,0,0,.659,1.1,3,3,0,0,1,1.185,1.42h.011a4.16,4.16,0,0,1,.452,1.681c0,1.01,1.826.908,3.1,1.64.645.366,1.489.776,2.489,1.317l.718-1.9Zm-16.56-14.711h0l2.443,2.2,0,0Z",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48879",
    "data-name": "Group 48879",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48878",
    "data-name": "Group 48878"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48877",
    "data-name": "Group 48877"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52384",
    "data-name": "Path 52384",
    d: "M221.715,107.288c-.733-.249-2.563.733-2.563.733-1.332,1.947-5.124,8.9-4.758,9.516a2.365,2.365,0,0,0,2.928,1.581c2.2-.366,3.91-1.583,4.026-.483.133,1.1,0,1.7,1.348,1.581s3.426,1.347,3.909.366-.132-3.294-.732-4.275v0c-.615-.967.249-3.529-1.464-3.529s-4.159.352-4.159-.864,2.2-4.379,1.465-4.628",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48882",
    "data-name": "Group 48882",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48881",
    "data-name": "Group 48881"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48880",
    "data-name": "Group 48880"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52385",
    "data-name": "Path 52385",
    d: "M147.662,113.436l0,.013.009-.012.556,2.019h3.1l1.094,1.34.725-.609.006.007.007-.006.844,1.033.914-.61.01,0,0,0,2.194.671.9-.116,1.9-.922.006,0,.007,0,7.13,5.067.981.425.791,1.347,1.948,1.4.673,3.836s0,2.255-.366,2.621-1.289,1.464-1.289,1.464-.291,1.171.381,1.347a4.758,4.758,0,0,0,1.934-.25l5.183-2.313-.249-1.889,4.275-.117s1.288-2.269,1.947-2.445a5.94,5.94,0,0,0,1.713-1.215h6.282v0h0l2.885,2.884h0c.6-.689,3.237-1.67,5.636-2.563l-.586-1.976-.863,0v0h.863l.586,1.977a30.548,30.548,0,0,0,3.864-1.611c1.832-1.1.616.981-.482,1.464s-1.478,2.211-1.23,3.544,3.177-1.347,4.025-1.83c.864-.5,3.295-2.065,6.223-3.661s.366-2.926-.365-3.426v.009c-.732-.483-2.795,2.1-3.777,1.962s-1.714-1.234-3.046-1.6c-1.348-.37-.852-1.2-.733-2.8s.236-3.294.236-4.026-4.76.849-6.092,1.83a4.8,4.8,0,0,1-2.517,1.011h0a.769.769,0,0,1-.542-.161c-.366-.366,4.275-3.411,6.721-5.124s8.054-.5,10.733-.615,6.705-4.261,8.418-6.34-1.713-4.275-3.045-5.241h-.006c-1.347-.981-1.362-2.331-3.06-3.06s-3.793-4.872-5.125-7.8-3.524-7.32-5.124-10.864c0,0-.293-.572-1.025.249s-2.475,5.4-5.124,5.945c-2.665.556-3.309-2.741-3.485-5.213s.541-2.84-1.376-3.572-3.1-3.557-5.3-5.3-3.482.177-6.412-1.01-2.563,2.562-2.651,4.758,1.1,2.737.732,6.047c-.366,3.276-2.278,3.484.279,6.676s.908,7.776-1.743,9.327c-2.651,1.567-2.914,1.741-1.274,4.216s.277,7.776-1.743,7.863-4.04-8.228-4.582-11.069-6.941-3.28-10.425-4.569-9.253-6.426-11.259-9.165-1.186-4.2-.732-6.486a22.773,22.773,0,0,1,3.747-7.321,11.27,11.27,0,0,1,2.841-1.917c1.1-1.113-.186-1.845-.644-2.387s.731,0,1.742-.366.555-1.376,2.562-1.376,2.475-2.736,3.207-4.115,0-1.1-.644-1.1-1.919-.821-3.573-1.64c-1.639-.835-.455-.833,1.376.176s2.2.732,3.1.453a2.2,2.2,0,0,0,1.112-1.112,4.309,4.309,0,0,0,.453-2.636c-.277-1.655-.453-1.479,1.011-1.01s2.285.732,3.836,0a10.532,10.532,0,0,0,4.217-3.924c1.464-2.109-1.656-4.582-1.377-5.959.268-1.361,1.468-2.928-.732-5.754a3.129,3.129,0,0,0-2.533-1.347,4.6,4.6,0,0,0-3.411,1.8c-.557.908,1.463,3.484.819,3.66s-1.111,3.762-2.664,6.222-2.931-1.377-2.739-3.66.107-2.738-1.551-4.392-1.468,2.109-2.2,3.836c-.732,1.743-1.011-1.464-1.011-3.294s-.644-1.64-2.109-2.006l-3.525.406,3.535-.408c-1.465-.367-.82-2.752-.366-4.757.454-2.021-2-6.135-4.113-7.966-.864-.747-1.158-1.04-1.158-1.23l-1.361-.176c-.032.293-.073.6-.132.952-.556,3.294-1.186,5.037-1.186,8.961,0,3.685,2.577,3.44,4.246,4.685h-.01a1.826,1.826,0,0,1,.323.264c1.64,1.551.634,4.656-.366,5.124-2.782,1.289-2.534,1.64-2.475,4.481.044,1.9-1.277-2.2-1.377-3.939-.043-.849-.643-1.171-1.4-1.288a24.885,24.885,0,0,0-2.518-.073c-1.377-.107-.73,2.545-1.83,3.1s-3.031.087-7.043-.645c-4.042-.732-4.3-2.65-5.228-3.923-.907-1.29-3.938,1.185-4.758,1.917s1.029,1.186.556,3.47-2.562-.264-3.573-1.376c-1.009-1.084-5.94.922-8.784.922s-1.011-1.553.556-2.475c.732-.425.776-.835.453-1.244a9.624,9.624,0,0,0-2.108-1.494c-1.655-1.011-3.383-.556-5.667-1.567a33.1,33.1,0,0,1-5.124-2.825c-1.283-.835-3.657-1.919-4.3-.645s-1.2,1.2-2.02-1.274-1.641,0-2.841,2.094c-1.185,2.108-1.932-1.831-2.928-4.027s-1.464-.441-1.64.556-1.377,1.1-2.109.645c-.732-.471-.819-.19-3.66.629-2.841.835-4.949,2.943-7.965,4.495s-6.208-2.3-9.048-2.665a3.473,3.473,0,0,1-1.4-.478l-.337,42.486.333.1.538.162.952.278,2.2-1.464,0,.008-2.2,1.461-.951-.279-.527,1.8h0c1.64.951,3.467,2.137,5.067,3.294l1.361-.234v-.008L69.5,81.408V79.944l2.387-.541,0,.008-2.385.541v1.464L67.687,82.88l-1.361.234a29.4,29.4,0,0,1,3.484,2.811,146.7,146.7,0,0,1,9.971,12.021l.675-1.009-.675,1.01c.366.5.673.936.892,1.288,1.714,2.68,3.793,5.858,5.008,8.171s-.849,1.344-1.464,2.079,3.69,2.873,5.973,4.6a5.688,5.688,0,0,1,1.684,2.139l.02.006,0-.009,2.5.7.384-2.369,52.152-.19Zm44.346,11.23a3.975,3.975,0,0,0,.922-.117,16.515,16.515,0,0,1,.791-2.255c.234-.365,1.94-3.471,1.947-3.484l.981.483.789-.352.791.6h0l-.789-.6-.791.351-.981-.482s-1.713,3.118-1.947,3.484a16.515,16.515,0,0,0-.791,2.255,3.99,3.99,0,0,1-.923.117c-.241,0-.424.216-.547.432.123-.217.306-.434.548-.434M66.259,80.179l1.233,1.229v.006Zm6.362,1.431v0l2.2,2.2,0,.006Zm9.707,10.978-3.846-1.837,0-.007,3.85,1.843Z",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48885",
    "data-name": "Group 48885",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48884",
    "data-name": "Group 48884"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48883",
    "data-name": "Group 48883"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52386",
    "data-name": "Path 52386",
    d: "M207.836,112.116a2.806,2.806,0,0,0-.469-.38,1.611,1.611,0,0,0-.542-.087c-.571-.016-1.141-.016-1.713-.03-.218-.014-.2.322-.234.542.337.148.234.207.454.5a5.083,5.083,0,0,0,2.987,1.874c.6.117,1.361.059,1.654-.483a.916.916,0,0,0,.044-.732v0c-.322-.79-1.509-.673-2.182-1.2",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48888",
    "data-name": "Group 48888",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48887",
    "data-name": "Group 48887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48886",
    "data-name": "Group 48886"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52387",
    "data-name": "Path 52387",
    d: "M152.051,4.183c2.11.952,10.909,2.651,17,3.061,3.383.219,5.93.043,6.062-.865.19-1.331,1.168-3.944,1.092-6.1H150.863a8.78,8.78,0,0,0-.086,2.189,2.042,2.042,0,0,0,1.274,1.713",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48891",
    "data-name": "Group 48891",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48890",
    "data-name": "Group 48890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48889",
    "data-name": "Group 48889"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52388",
    "data-name": "Path 52388",
    d: "M169.009,10.731c-1.552,0-2.5.63-2.679,1.508-.366,1.83-2.194-.366-3.294-.732a7.864,7.864,0,0,0-2.2-.366c-1.829,3.294-5.126,13.542-2.929,16.105s4.027,6.223,10.249,6.589c.118,0,.235.014.352.014,6,.293,9.21-1.068,11.728,1.084,2.562,2.2,13.909,10.249,8.785,15.739-3.983,4.275-11.2,10.235-10.322,11.875.248.463,1.156.58,3,.2C192.315,60.551,197.44,73,200.734,71.9s4.392-6.223,1.464-11.347-2.562-10.982.366-7.687,12.079,3.661,3.66-5.49l0,0c-8.419-9.151-6.589-13.543-10.249-16.471S185.729,21.756,182.8,18.828s-1.464-1.83-6.954-5.491c-2.838-1.888-5.184-2.606-6.838-2.606",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48894",
    "data-name": "Group 48894",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48893",
    "data-name": "Group 48893"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48892",
    "data-name": "Group 48892"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52389",
    "data-name": "Path 52389",
    d: "M181.012,43.921a5.624,5.624,0,0,0,.044,3.85l1.23,1.084a1.238,1.238,0,0,0,1.274.234c1.171-.542,1.654-2.094,1.8-3.368.131-1.024.176-2.225-.731-2.884h0c-1.143-.849-3.018-.1-3.618,1.084",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48897",
    "data-name": "Group 48897",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48896",
    "data-name": "Group 48896"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48895",
    "data-name": "Group 48895"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52390",
    "data-name": "Path 52390",
    d: "M173.648,61.288c-1.787-2.548-3.572-.908-6.223-5.667a1.6,1.6,0,0,0-1.859-.585l-.425.132a1.409,1.409,0,0,0-.849.7,1.481,1.481,0,0,0-.117.367c-.5,2.913-2.855,5.256-1.508,7.613,1.464,2.562,5.491,4.394,6.223,2.562s2.926-1.1,4.026-1.1c.908,0,2.576-.248,1.654-2.43v.008a7.6,7.6,0,0,0-.922-1.6",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48900",
    "data-name": "Group 48900",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48899",
    "data-name": "Group 48899"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48898",
    "data-name": "Group 48898"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52391",
    "data-name": "Path 52391",
    d: "M152.05,17.813c2.372-.088,1.64-.542,3.206-5.125,1.553-4.568.176-3.1-1.185-3.294h0c-1.376-.175-1.742-.82-4.583-.82h-.073c-2.766.074-2.4,3.968-2.942,7.687a12.644,12.644,0,0,0-.147,2.636,22.818,22.818,0,0,1,.279,4.011l1.361.176c0-.263.63-.322,1.069-1.244a3.98,3.98,0,0,0,.176-3.66c-.459-1.274.469-.278,2.841-.366",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48903",
    "data-name": "Group 48903",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48902",
    "data-name": "Group 48902"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48901",
    "data-name": "Group 48901"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52392",
    "data-name": "Path 52392",
    d: "M153.6,37.038h0Z",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48906",
    "data-name": "Group 48906",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48905",
    "data-name": "Group 48905"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48904",
    "data-name": "Group 48904"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52393",
    "data-name": "Path 52393",
    d: "M145.946,3.933c.908.507,2.269,1.507,3.191,1.507.762,0,1.215-.687.835-2.869-.029-.186-.073-.38-.117-.586a16.474,16.474,0,0,0-.456-1.7h-3.934c-.81,1.548-.719,2.97.481,3.652",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48909",
    "data-name": "Group 48909",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48908",
    "data-name": "Group 48908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48907",
    "data-name": "Group 48907"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52394",
    "data-name": "Path 52394",
    d: "M143.5,35.206c-.88-1.245-1.7-.776-1.7-.776-.409,1.1-.087,2.928-.966,3.47-.5.322-1.024.629-1.142.981-.088.249.031.527.512.849.967.66,2.755,2.11,4.043,2.3a1.4,1.4,0,0,0,.658-.059c1.244-.454,1.845-1.185.923-2.972h0a33.067,33.067,0,0,0-2.328-3.792",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48912",
    "data-name": "Group 48912",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48911",
    "data-name": "Group 48911"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48910",
    "data-name": "Group 48910"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52395",
    "data-name": "Path 52395",
    d: "M141.8,25.661c1.45-1.83,3.456-4.612,3.456-6.706a2.347,2.347,0,0,0-.776-1.844h0c-2.2-1.948.981-8.288-2.43-8.537-2.255-.16-4.026,2.446-5.3,3.075a1.4,1.4,0,0,0-.689,1.743c.542,1.435,1.114,2.254-.849,3.235-.981.482-1.42.775-1.42,1.2,0,.614.935,1.492,2.4,3.674,2.43,3.659,3.66,6.589,5.607,4.159",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48915",
    "data-name": "Group 48915",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48914",
    "data-name": "Group 48914"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48913",
    "data-name": "Group 48913"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52396",
    "data-name": "Path 52396",
    d: "M142.409.281h-5.585c.176.22.361.456.585.725.994,1.2,3.955,2.067,5-.725",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48918",
    "data-name": "Group 48918",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48917",
    "data-name": "Group 48917"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48916",
    "data-name": "Group 48916"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52397",
    "data-name": "Path 52397",
    d: "M137.761,38.27a.577.577,0,0,0-.278.1.527.527,0,0,0-.132.233,1.327,1.327,0,0,1-.059.147c-.251.659-.851,2.109.249,2.109a.813.813,0,0,0,.629-.25,2.567,2.567,0,0,0,.293-.688,8.248,8.248,0,0,0,.542-1.011.426.426,0,0,0,.029-.146.292.292,0,0,0-.029-.249v0a.5.5,0,0,0-.279-.161,2.41,2.41,0,0,0-.966-.087",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48921",
    "data-name": "Group 48921",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48920",
    "data-name": "Group 48920"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48919",
    "data-name": "Group 48919"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52398",
    "data-name": "Path 52398",
    d: "M126.427,11.869c-4.026,3.66-4.757,8.786-7.686,6.589s-6.955-5.491-9.517-4.027a26,26,0,0,0-4.762,3.656c-1.466,2.562-1.83,6.222-.366,6.588s.366,2.56.732,4.026,3.29,1.1,6.222,1.1,6.958,1.465,2.2,2.563-8.052,1.464-5.124,4.026c1.6,1.391,2.635,3.749,4.026,5.33a3.862,3.862,0,0,0,4.759,1.258c4.758-1.83,9.878-4.392,12.078-4.392,1.67,0,6.048,1.469,6.97-.2.308-.524.249-1.392-.38-2.724-2.562-5.491-5.124-6.223-5.856-10.249a68.2,68.2,0,0,1-.309-7.482c-.132-4.349-.557-8.272-2.987-6.062",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48924",
    "data-name": "Group 48924",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48923",
    "data-name": "Group 48923"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48922",
    "data-name": "Group 48922"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52399",
    "data-name": "Path 52399",
    d: "M106.662,1.986c4.756.366,5.49,1.83,5.856,3.294s4.393-.366,8.053-1.464c3.342-1,6.676-.794,7.789-3.535H104.454c.015.952.606,1.582,2.208,1.7",
    fill: "#eceef0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48927",
    "data-name": "Group 48927",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48926",
    "data-name": "Group 48926"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48925",
    "data-name": "Group 48925"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52400",
    "data-name": "Path 52400",
    d: "M97.877,26.875c2.925-3.66,2.563-8.417,5.125-9.516s12.079-5.125,4.392-8.053h0a33.739,33.739,0,0,0-12.533-2.02A3.177,3.177,0,0,0,91.8,9.965c-.585,3.645-1.889,9.952-.512,12.152,1.83,2.928,3.663,8.418,6.588,4.758",
    fill: "#eceef0"
  }))))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52401",
    "data-name": "Path 52401",
    d: "M11.549,56.467a3.058,3.058,0,0,1,1.963,2.679c.237,1.772,2.737,1.523,2.737,1.523,1.581,0,6.838-1.581,7.322,1.231.482,2.8-1.949,3.411-4.028,3.411s-3.417,2.682-5.13,5.974,2.8,8.3,3.411,8.3,3.3-.6,3.91.981.482,3.662,1.713,3.162c1.215-.483,2.324.013,4.392.132s2.2.471,2.2,1.7-1.6,3.778-3.543,5.491-6.334,3.426-8.9,5.007-1.7,2.313-.366,2.562,4.144-2.313,9.752-5.373A31.832,31.832,0,0,0,38.33,82.762c1.962-3.06-1.1-.994,0-3.06s2.943-1.6,3.06-.366.483,2.079,1.581,1.713,5.008-2.313,5.008-2.679.6-2.445,1.83-2.812c1.215-.365,4.875,1.946,7.437,2.446a15.653,15.653,0,0,1,4.011,1.816l.527-1.8h0l-.545-.166-.34-.1.336-42.489.008,0v0c-1.54-.908-1.95-2.679-4-2.167-2.562.644-2.664-.1-5.314-.278s-5.3-1.729-7.95-1.377c-2.651.38-4.847-1.919-7.233-2.548-2.387-.645-3.572-1.654-5.857-.835-2.283.839-6.135,3.12-7.862,3.939-1.742.82-2.474,2.928-3.485,4.949s-2.107,2.738-3.747,2.825c-1.655.1-1.464-.176-1.684.337a9.1,9.1,0,0,0,0,2.928c.306.673,2.985,2.181,3.6,3.045s1.274,2.269,1.83,2.578a12.061,12.061,0,0,1,3.544,3.28c.656,1.288-2.563,1.654-3.544,1.654s.176-1.521,0-2.137-1.142-.718-1.947-.542-3.353,2.253-5.373,3.353c-1.006.548-1.373,1.005-1.39,1.372v.011c-.009.363.324.635.717.817",
    fill: "#3cb5fb"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52402",
    "data-name": "Path 52402",
    d: "M60.9,77.752l.34.1-.333-.1.337-42.486-.008,0Z",
    fill: "#5fb3f4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19242",
    "data-name": "Rectangle 19242",
    width: 0.001,
    height: 1.875,
    transform: "translate(61.52 77.982)",
    fill: "#5fb3f4"
  })))))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46895",
    "data-name": "Group 46895",
    transform: "translate(3106.637 4014.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20243",
    "data-name": "Group 20243",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4337",
    "data-name": "Ellipse 4337",
    cx: 11.661,
    cy: 11.661,
    r: 11.661,
    transform: "translate(0 0)",
    opacity: 0.8,
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20244",
    "data-name": "Group 20244",
    transform: "translate(4.165 4.165)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4347",
    "data-name": "Ellipse 4347",
    cx: 7.497,
    cy: 7.497,
    r: 7.497,
    transform: "translate(0 0)",
    fill: "#3db6fb",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20245",
    "data-name": "Group 20245",
    transform: "translate(7.497 7.497)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4350",
    "data-name": "Ellipse 4350",
    cx: 3.914,
    cy: 3.914,
    r: 3.914,
    transform: "translate(0 0)",
    fill: "#13dbb5"
  })))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46912",
    "data-name": "Group 46912",
    transform: "translate(3080.412 4048.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20243-2",
    "data-name": "Group 20243",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4337-2",
    "data-name": "Ellipse 4337",
    cx: 11.661,
    cy: 11.661,
    r: 11.661,
    transform: "translate(0 0)",
    opacity: 0.8,
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20244-2",
    "data-name": "Group 20244",
    transform: "translate(4.165 4.165)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4347-2",
    "data-name": "Ellipse 4347",
    cx: 7.497,
    cy: 7.497,
    r: 7.497,
    transform: "translate(0 0)",
    fill: "#3db6fb",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20245-2",
    "data-name": "Group 20245",
    transform: "translate(7.497 7.497)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4350-2",
    "data-name": "Ellipse 4350",
    cx: 3.914,
    cy: 3.914,
    r: 3.914,
    transform: "translate(0 0)",
    fill: "#13dbb5"
  })))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46908",
    "data-name": "Group 46908",
    transform: "translate(3080.412 3989.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20243-3",
    "data-name": "Group 20243",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4337-3",
    "data-name": "Ellipse 4337",
    cx: 11.661,
    cy: 11.661,
    r: 11.661,
    transform: "translate(0 0)",
    opacity: 0.8,
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20244-3",
    "data-name": "Group 20244",
    transform: "translate(4.165 4.165)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4347-3",
    "data-name": "Ellipse 4347",
    cx: 7.497,
    cy: 7.497,
    r: 7.497,
    transform: "translate(0 0)",
    fill: "#3db6fb",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20245-3",
    "data-name": "Group 20245",
    transform: "translate(7.497 7.497)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4350-3",
    "data-name": "Ellipse 4350",
    cx: 3.914,
    cy: 3.914,
    r: 3.914,
    transform: "translate(0 0)",
    fill: "#13dbb5"
  })))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46896",
    "data-name": "Group 46896",
    transform: "translate(3048.3 3946.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20216",
    "data-name": "Group 20216",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4337-4",
    "data-name": "Ellipse 4337",
    cx: 22.073,
    cy: 21.657,
    rx: 22.073,
    ry: 21.657,
    transform: "translate(0 0)",
    opacity: 0.8,
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20217",
    "data-name": "Group 20217",
    transform: "translate(7.497 7.497)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4347-4",
    "data-name": "Ellipse 4347",
    cx: 14.577,
    cy: 14.577,
    r: 14.577,
    transform: "translate(0 0)",
    fill: "#3db6fb",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20218",
    "data-name": "Group 20218",
    transform: "translate(18.325 18.325)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4350-4",
    "data-name": "Ellipse 4350",
    cx: 3.582,
    cy: 3.582,
    r: 3.582,
    transform: "translate(0 0)",
    fill: "#13dbb5"
  })))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46897",
    "data-name": "Group 46897",
    transform: "translate(3022.062 3988.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45982",
    "data-name": "Group 45982",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20250",
    "data-name": "Group 20250",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4337-5",
    "data-name": "Ellipse 4337",
    cx: 24.156,
    cy: 24.156,
    r: 24.156,
    opacity: 0.8,
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20251",
    "data-name": "Group 20251",
    transform: "translate(5.831 5.831)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4347-5",
    "data-name": "Ellipse 4347",
    cx: 18.325,
    cy: 18.325,
    r: 18.325,
    transform: "translate(0 0)",
    fill: "#3db6fb",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20252",
    "data-name": "Group 20252",
    transform: "translate(13.328 13.327)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4350-5",
    "data-name": "Ellipse 4350",
    cx: 10.756,
    cy: 10.756,
    r: 10.756,
    transform: "translate(0 0)",
    fill: "#13dbb5"
  }))))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46898",
    "data-name": "Group 46898",
    transform: "translate(3264.034 3947.248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45982-2",
    "data-name": "Group 45982",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20250-2",
    "data-name": "Group 20250",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4337-6",
    "data-name": "Ellipse 4337",
    cx: 24.156,
    cy: 24.156,
    r: 24.156,
    opacity: 0.8,
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20251-2",
    "data-name": "Group 20251",
    transform: "translate(5.831 5.831)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4347-6",
    "data-name": "Ellipse 4347",
    cx: 18.325,
    cy: 18.325,
    r: 18.325,
    transform: "translate(0 0)",
    fill: "#3db6fb",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20252-2",
    "data-name": "Group 20252",
    transform: "translate(13.328 13.327)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4350-6",
    "data-name": "Ellipse 4350",
    cx: 10.756,
    cy: 10.756,
    r: 10.756,
    transform: "translate(0 0)",
    fill: "#13dbb5"
  }))))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46899",
    "data-name": "Group 46899",
    transform: "translate(2977.529 3927.764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20243-4",
    "data-name": "Group 20243",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4337-7",
    "data-name": "Ellipse 4337",
    cx: 11.661,
    cy: 11.661,
    r: 11.661,
    transform: "translate(0 0)",
    opacity: 0.8,
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20244-4",
    "data-name": "Group 20244",
    transform: "translate(4.165 4.165)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4347-7",
    "data-name": "Ellipse 4347",
    cx: 7.497,
    cy: 7.497,
    r: 7.497,
    transform: "translate(0 0)",
    fill: "#3db6fb",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20245-4",
    "data-name": "Group 20245",
    transform: "translate(7.497 7.497)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4350-7",
    "data-name": "Ellipse 4350",
    cx: 3.914,
    cy: 3.914,
    r: 3.914,
    transform: "translate(0 0)",
    fill: "#13dbb5"
  })))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46909",
    "data-name": "Group 46909",
    transform: "translate(3106.637 4157.66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20243-5",
    "data-name": "Group 20243",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4337-8",
    "data-name": "Ellipse 4337",
    cx: 11.661,
    cy: 11.661,
    r: 11.661,
    transform: "translate(0 0)",
    opacity: 0.8,
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20244-5",
    "data-name": "Group 20244",
    transform: "translate(4.165 4.165)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4347-8",
    "data-name": "Ellipse 4347",
    cx: 7.497,
    cy: 7.497,
    r: 7.497,
    transform: "translate(0 0)",
    fill: "#3db6fb",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20245-5",
    "data-name": "Group 20245",
    transform: "translate(7.497 7.497)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4350-8",
    "data-name": "Ellipse 4350",
    cx: 3.914,
    cy: 3.914,
    r: 3.914,
    transform: "translate(0 0)",
    fill: "#13dbb5"
  })))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46913",
    "data-name": "Group 46913",
    transform: "translate(3156.145 4120.615)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20243-6",
    "data-name": "Group 20243",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4337-9",
    "data-name": "Ellipse 4337",
    cx: 12.397,
    cy: 11.806,
    rx: 12.397,
    ry: 11.806,
    opacity: 0.8,
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20244-6",
    "data-name": "Group 20244",
    transform: "translate(4.723 3.541)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4347-9",
    "data-name": "Ellipse 4347",
    cx: 7.674,
    cy: 7.674,
    r: 7.674,
    transform: "translate(0 0)",
    fill: "#3db6fb",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20245-6",
    "data-name": "Group 20245",
    transform: "translate(8.352 7.433)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4350-9",
    "data-name": "Ellipse 4350",
    cx: 3.914,
    cy: 3.914,
    r: 3.914,
    transform: "translate(0 0)",
    fill: "#13dbb5"
  })))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46900",
    "data-name": "Group 46900",
    transform: "translate(3312.346 4001.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20243-7",
    "data-name": "Group 20243",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4337-10",
    "data-name": "Ellipse 4337",
    cx: 11.661,
    cy: 11.661,
    r: 11.661,
    transform: "translate(0 0)",
    opacity: 0.8,
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20244-7",
    "data-name": "Group 20244",
    transform: "translate(4.165 4.165)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4347-10",
    "data-name": "Ellipse 4347",
    cx: 7.497,
    cy: 7.497,
    r: 7.497,
    transform: "translate(0 0)",
    fill: "#3db6fb",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20245-7",
    "data-name": "Group 20245",
    transform: "translate(7.497 7.497)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4350-10",
    "data-name": "Ellipse 4350",
    cx: 3.914,
    cy: 3.914,
    r: 3.914,
    transform: "translate(0 0)",
    fill: "#13dbb5"
  })))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46901",
    "data-name": "Group 46901",
    transform: "translate(3270.729 4107.367)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20222",
    "data-name": "Group 20222",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4337-11",
    "data-name": "Ellipse 4337",
    cx: 27.071,
    cy: 27.071,
    r: 27.071,
    transform: "translate(0 0)",
    opacity: 0.8,
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20223",
    "data-name": "Group 20223",
    transform: "translate(10.828 10.828)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4347-11",
    "data-name": "Ellipse 4347",
    cx: 16.243,
    cy: 16.243,
    r: 16.243,
    transform: "translate(0 0)",
    fill: "#3db6fb",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20224",
    "data-name": "Group 20224",
    transform: "translate(16.163 16.163)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4350-11",
    "data-name": "Ellipse 4350",
    cx: 10.908,
    cy: 10.908,
    r: 10.908,
    transform: "translate(0 0)",
    fill: "#13dbb5"
  })))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46902",
    "data-name": "Group 46902",
    transform: "translate(3224.917 3992.251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20243-8",
    "data-name": "Group 20243",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4337-12",
    "data-name": "Ellipse 4337",
    cx: 11.661,
    cy: 11.661,
    r: 11.661,
    transform: "translate(0 0)",
    opacity: 0.8,
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20244-8",
    "data-name": "Group 20244",
    transform: "translate(4.165 4.165)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4347-12",
    "data-name": "Ellipse 4347",
    cx: 7.497,
    cy: 7.497,
    r: 7.497,
    transform: "translate(0 0)",
    fill: "#3db6fb",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20245-8",
    "data-name": "Group 20245",
    transform: "translate(7.497 7.497)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4350-12",
    "data-name": "Ellipse 4350",
    cx: 3.914,
    cy: 3.914,
    r: 3.914,
    transform: "translate(0 0)",
    fill: "#13dbb5"
  })))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46911",
    "data-name": "Group 46911",
    transform: "translate(3213.255 3911.105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20243-9",
    "data-name": "Group 20243",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4337-13",
    "data-name": "Ellipse 4337",
    cx: 11.661,
    cy: 11.661,
    r: 11.661,
    transform: "translate(0 0)",
    opacity: 0.8,
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20244-9",
    "data-name": "Group 20244",
    transform: "translate(4.165 4.165)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4347-13",
    "data-name": "Ellipse 4347",
    cx: 7.497,
    cy: 7.497,
    r: 7.497,
    transform: "translate(0 0)",
    fill: "#3db6fb",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20245-9",
    "data-name": "Group 20245",
    transform: "translate(7.497 7.497)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4350-13",
    "data-name": "Ellipse 4350",
    cx: 3.914,
    cy: 3.914,
    r: 3.914,
    transform: "translate(0 0)",
    fill: "#13dbb5"
  })))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46903",
    "data-name": "Group 46903",
    transform: "translate(3129.127 4066.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20216-2",
    "data-name": "Group 20216",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4337-14",
    "data-name": "Ellipse 4337",
    cx: 22.073,
    cy: 21.657,
    rx: 22.073,
    ry: 21.657,
    transform: "translate(0 0)",
    opacity: 0.8,
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20217-2",
    "data-name": "Group 20217",
    transform: "translate(7.497 7.497)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4347-14",
    "data-name": "Ellipse 4347",
    cx: 14.577,
    cy: 14.577,
    r: 14.577,
    transform: "translate(0 0)",
    fill: "#3db6fb",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20218-2",
    "data-name": "Group 20218",
    transform: "translate(18.325 18.325)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4350-14",
    "data-name": "Ellipse 4350",
    cx: 3.582,
    cy: 3.582,
    r: 3.582,
    transform: "translate(0 0)",
    fill: "#13dbb5"
  })))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46910",
    "data-name": "Group 46910",
    transform: "translate(3236.578 4050.583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20216-3",
    "data-name": "Group 20216",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4337-15",
    "data-name": "Ellipse 4337",
    cx: 22.073,
    cy: 21.657,
    rx: 22.073,
    ry: 21.657,
    transform: "translate(0 0)",
    opacity: 0.8,
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20217-3",
    "data-name": "Group 20217",
    transform: "translate(7.497 7.497)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4347-15",
    "data-name": "Ellipse 4347",
    cx: 14.577,
    cy: 14.577,
    r: 14.577,
    transform: "translate(0 0)",
    fill: "#3db6fb",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20218-3",
    "data-name": "Group 20218",
    transform: "translate(18.325 18.325)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4350-15",
    "data-name": "Ellipse 4350",
    cx: 3.582,
    cy: 3.582,
    r: 3.582,
    transform: "translate(0 0)",
    fill: "#13dbb5"
  })))))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48772",
    "data-name": "Group 48772",
    transform: "translate(1049.063 4121.235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48280",
    "data-name": "Group 48280",
    transform: "translate(910 -675)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 875.71, 325.26)",
    filter: "url(#Rectangle_18909)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18909-2",
    "data-name": "Rectangle 18909",
    width: 285.391,
    height: 285.391,
    rx: 30,
    transform: "translate(612.36 232.61)",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48275",
    "data-name": "Group 48275",
    transform: "translate(3777.193 12326.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48273",
    "data-name": "Group 48273",
    transform: "translate(-2157.651 -11740.375)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17554",
    "data-name": "Rectangle 17554",
    width: 16.142,
    height: 7.511,
    transform: "translate(1.351 95.324)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17556",
    "data-name": "Rectangle 17556",
    width: 18.569,
    height: 7.511,
    transform: "translate(0 71.541)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17558",
    "data-name": "Rectangle 17558",
    width: 16.068,
    height: 7.511,
    transform: "translate(1.351 22.893)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17560",
    "data-name": "Rectangle 17560",
    width: 11.785,
    height: 7.511,
    transform: "translate(3.378 44.514)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17562",
    "data-name": "Rectangle 17562",
    width: 13.513,
    height: 7.511,
    transform: "translate(2.703 0.191)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_100",
    "data-name": 100,
    transform: "translate(2.703 101.457)",
    fill: "#3eb6fb",
    fontSize: 7,
    fontFamily: "ProximaNova-Regular, Proxima Nova"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "100")), /*#__PURE__*/React.createElement("text", {
    id: "_500",
    "data-name": 500,
    transform: "translate(1.351 77.673)",
    fill: "#3eb6fb",
    fontSize: 7,
    fontFamily: "ProximaNova-Regular, Proxima Nova"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "500")), /*#__PURE__*/React.createElement("text", {
    id: "_1_5K",
    "data-name": "1,5K",
    transform: "translate(1.351 29.026)",
    fill: "#3eb6fb",
    fontSize: 7,
    fontFamily: "ProximaNova-Regular, Proxima Nova"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1,5K")), /*#__PURE__*/React.createElement("text", {
    id: "_1K",
    "data-name": "1K",
    transform: "translate(5.405 49.971)",
    fill: "#3eb6fb",
    fontSize: 6,
    fontFamily: "ProximaNova-Regular, Proxima Nova"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1K")), /*#__PURE__*/React.createElement("text", {
    id: "_2K",
    "data-name": "2K",
    transform: "translate(4.054 6)",
    fill: "#3eb6fb",
    fontSize: 7,
    fontFamily: "ProximaNova-Regular, Proxima Nova"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2K"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48270",
    "data-name": "Group 48270",
    transform: "translate(-2263.158 -11739.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46904",
    "data-name": "Group 46904",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46893",
    "data-name": "Group 46893",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45995",
    "data-name": "Path 45995",
    d: "M.39,268.869,0,268.381Z",
    transform: "translate(0 -123.314)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45996",
    "data-name": "Path 45996",
    d: "M385.492,264.023,406.107,238.2ZM406.107,238.2l-8.112-35.511Z",
    transform: "translate(-177.123 -93.128)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45997",
    "data-name": "Path 45997",
    d: "M63.926,348.474.843,269.438Z",
    transform: "translate(-0.387 -123.799)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45998",
    "data-name": "Path 45998",
    d: "M110.663,7.332h0L23.718,49.167,2.266,143.073,23.718,49.167Z",
    transform: "translate(-1.041 -3.369)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45999",
    "data-name": "Path 45999",
    d: "M251.436,22.06,221.154,7.49Z",
    transform: "translate(-101.614 -3.441)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46000",
    "data-name": "Path 46000",
    d: "M22.677,49.167,1.225,143.074,0,148.436l.39.488-.265-.946,1.164-.326L23.457,50.606l-.8-.588.638-.872.763.558L109.622,8.531v-1.2Z",
    transform: "translate(0 -3.369)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46001",
    "data-name": "Path 46001",
    d: "M205.943,87.03,228.2,184.469,165.683,262.8l.433.948-.984.449-.426-.933H65.5l-.4.875-.984-.445.241-.532L1.974,184.992l-1.131.316,63.083,79.036H165.833l42.924-53.78,20.614-25.828-8.112-35.511L206.893,86.337Z",
    transform: "translate(-0.387 -39.669)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46002",
    "data-name": "Path 46002",
    d: "M221.153,8.689l85.509,41.144.844-.616.6.817-.182-.795L251.435,22.06,221.153,7.49Z",
    transform: "translate(-101.614 -3.441)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46003",
    "data-name": "Path 46003",
    d: "M288.051,321.214v0l49.4-62Z",
    transform: "translate(-132.351 -119.103)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46004",
    "data-name": "Path 46004",
    d: "M380.8,257.045l.45-.565Z",
    transform: "translate(-174.965 -117.846)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17543",
    "data-name": "Rectangle 17543",
    width: 0.001,
    height: 80.334,
    transform: "translate(48.681 130.391)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17544",
    "data-name": "Rectangle 17544",
    width: 0.003,
    height: 79.912,
    transform: "translate(80.428 181.79) rotate(-58.991)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46005",
    "data-name": "Path 46005",
    d: "M143.275,50.025h0l-66.5,32.052Z",
    transform: "translate(-35.275 -22.985)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46006",
    "data-name": "Path 46006",
    d: "M65.184,111.314,52.333,167.662Z",
    transform: "translate(-24.045 -51.146)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46007",
    "data-name": "Path 46007",
    d: "M44.41,188.916l17.54-76.907-.95-.7L48.148,167.662l-4.923,21.585Z",
    transform: "translate(-19.861 -51.146)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46008",
    "data-name": "Path 46008",
    d: "M289.8,82.541l.99-.723L224.153,49.7v1.2Z",
    transform: "translate(-102.992 -22.837)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46009",
    "data-name": "Path 46009",
    d: "M44.882,256.838l-1.13.316L93.816,319.98l.5-1.1Z",
    transform: "translate(-20.103 -118.01)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46010",
    "data-name": "Path 46010",
    d: "M138.72,372.4l-.488,1.079h79.912l-.492-1.079Z",
    transform: "translate(-63.514 -171.108)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46011",
    "data-name": "Path 46011",
    d: "M143.275,51.226v-1.2l-66.5,32.052.989.723Z",
    transform: "translate(-35.275 -22.985)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46012",
    "data-name": "Path 46012",
    d: "M346.664,111.567l17.73,77.745-.4.5,1.122.327.45-.565-17.949-78.7Z",
    transform: "translate(-159.282 -50.943)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46013",
    "data-name": "Path 46013",
    d: "M287.121,319.834l.5,1.1,49.4-62-1.122-.327Z",
    transform: "translate(-131.924 -118.825)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46014",
    "data-name": "Path 46014",
    d: "M101.909,136.561,91.652,181.646Z",
    transform: "translate(-42.111 -62.746)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46015",
    "data-name": "Path 46015",
    d: "M196.521,90.519l-8.977,4.337Z",
    transform: "translate(-86.171 -41.591)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46016",
    "data-name": "Path 46016",
    d: "M268.432,292.112h0l36.305-45.675Z",
    transform: "translate(-123.337 -113.232)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17545",
    "data-name": "Rectangle 17545",
    width: 0.001,
    height: 59.714,
    transform: "translate(65.337 126.19)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17546",
    "data-name": "Rectangle 17546",
    width: 0.002,
    height: 59.278,
    transform: "translate(88.148 166.356) rotate(-63.304)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46017",
    "data-name": "Path 46017",
    d: "M161.795,90.519l-8.977,4.337L111.965,114.6l.989.723,48.841-23.6Z",
    transform: "translate(-51.445 -41.591)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46018",
    "data-name": "Path 46018",
    d: "M87.5,193.995l12.907-56.739-.95-.695L89.2,181.646l-2.885,12.68Z",
    transform: "translate(-39.659 -62.746)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46019",
    "data-name": "Path 46019",
    d: "M87.635,244.867l-1.13.316,37.157,46.745.5-1.106Z",
    transform: "translate(-39.747 -112.51)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46020",
    "data-name": "Path 46020",
    d: "M216.018,330.4h-58.3l-.488,1.079h59.276Z",
    transform: "translate(-72.245 -151.81)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46021",
    "data-name": "Path 46021",
    d: "M323.628,194.957l1.188.346-13.227-58.14-.951.694Z",
    transform: "translate(-142.729 -63.023)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46022",
    "data-name": "Path 46022",
    d: "M268.38,115.706l.99-.722L219.8,91.036v1.2Z",
    transform: "translate(-100.994 -41.828)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46023",
    "data-name": "Path 46023",
    d: "M268,291.834l36.306-45.674-1.121-.327-35.688,44.9Z",
    transform: "translate(-122.909 -112.954)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46024",
    "data-name": "Path 46024",
    d: "M145.041,166.5h0l-7.674,33.856Z",
    transform: "translate(-63.116 -76.502)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17547",
    "data-name": "Rectangle 17547",
    height: 27.406,
    transform: "translate(94.777 69.358)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46025",
    "data-name": "Path 46025",
    d: "M179.729,282.674h0Z",
    transform: "translate(-82.58 -129.881)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46026",
    "data-name": "Path 46026",
    d: "M273.066,170.91l-.981-4.327Z",
    transform: "translate(-125.015 -76.54)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46027",
    "data-name": "Path 46027",
    d: "M250.331,154.657h0L225.8,142.763Z",
    transform: "translate(-103.751 -65.596)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46028",
    "data-name": "Path 46028",
    d: "M225.8,143.965l23.538,11.413.989-.722L225.8,142.763Z",
    transform: "translate(-103.751 -65.596)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46029",
    "data-name": "Path 46029",
    d: "M177.19,143.807v-1.2l-24.66,11.958.988.722Z",
    transform: "translate(-70.083 -65.524)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46030",
    "data-name": "Path 46030",
    d: "M179.729,281.755h34.848l-.493-1.081H180.218Z",
    transform: "translate(-82.58 -128.962)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46031",
    "data-name": "Path 46031",
    d: "M270.325,167.276l7.54,33.26,1.187.346-6.794-29.973-.981-4.327Z",
    transform: "translate(-124.207 -76.54)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46032",
    "data-name": "Path 46032",
    d: "M138.853,230.526l-1.129.316,21.721,27.424.5-1.108Z",
    transform: "translate(-63.28 -105.921)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46033",
    "data-name": "Path 46033",
    d: "M145.041,166.5l-7.675,33.855,1.184-.331,7.441-32.829Z",
    transform: "translate(-63.116 -76.503)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46034",
    "data-name": "Path 46034",
    d: "M244.98,257.34l.5,1.1,21.323-26.923-1.121-.326Z",
    transform: "translate(-112.561 -106.228)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46035",
    "data-name": "Path 46035",
    d: "M184.441,192.336l-2.882,12.374Z",
    transform: "translate(-83.421 -88.373)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46036",
    "data-name": "Path 46036",
    d: "M237.455,195.4l-.707-3.036Z",
    transform: "translate(-108.779 -88.388)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46037",
    "data-name": "Path 46037",
    d: "M181.79,218.773h0l8.565,10.526Z",
    transform: "translate(-83.527 -100.52)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46038",
    "data-name": "Path 46038",
    d: "M195.012,185.11l-6.661,3.144Z",
    transform: "translate(-86.542 -85.053)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46039",
    "data-name": "Path 46039",
    d: "M195.012,186.305v-1.2l-6.661,3.144.993.726Z",
    transform: "translate(-86.542 -85.053)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46040",
    "data-name": "Path 46040",
    d: "M199.578,237.884h13.294l-.493-1.081H200.067Z",
    transform: "translate(-91.7 -108.805)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46041",
    "data-name": "Path 46041",
    d: "M225.147,228l.5,1.1,8.4-10.324-1.126-.328Z",
    transform: "translate(-103.449 -100.369)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46042",
    "data-name": "Path 46042",
    d: "M182.364,205.264l2.849-12.234-.949-.694-2.882,12.374-.207.885Z",
    transform: "translate(-83.245 -88.373)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46043",
    "data-name": "Path 46043",
    d: "M228.791,189.059l.995-.726-6.5-3.069v1.2Z",
    transform: "translate(-102.592 -85.124)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46044",
    "data-name": "Path 46044",
    d: "M234.993,193.062l2.889,12.4,1.191.347-2.424-10.407-.707-3.036Z",
    transform: "translate(-107.973 -88.389)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46045",
    "data-name": "Path 46045",
    d: "M182.925,218.185l-1.135.318,8.565,10.526.5-1.1Z",
    transform: "translate(-83.527 -100.25)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46046",
    "data-name": "Path 46046",
    d: "M382.031,86.273l.024-.018-.041-.056Z",
    transform: "translate(-175.525 -39.606)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46047",
    "data-name": "Path 46047",
    d: "M364.685,85.828l-17.25,12.588.359.173.177.775L365.192,86.8l-.186-.814Z",
    transform: "translate(-159.637 -39.436)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46048",
    "data-name": "Path 46048",
    d: "M382.03,86.273h0l-.017-.074Z",
    transform: "translate(-175.524 -39.606)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46049",
    "data-name": "Path 46049",
    d: "M380.193,84.688l-.844.616.321.154.186.814.951-.694-.017-.074Z",
    transform: "translate(-174.3 -38.912)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46050",
    "data-name": "Path 46050",
    d: "M329.935,110.455,311.5,123.906l.292.141.192.844,18.521-13.516-.165-.722Z",
    transform: "translate(-143.127 -50.751)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46051",
    "data-name": "Path 46051",
    d: "M347.434,109.118l.357.172.177.776,0,0-.177-.774-.359-.173Z",
    transform: "translate(-159.636 -50.136)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46052",
    "data-name": "Path 46052",
    d: "M346.012,110.038l.165.722.95-.694-.177-.776-.357-.172-.99.723Z",
    transform: "translate(-158.794 -50.137)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46053",
    "data-name": "Path 46053",
    d: "M311.5,135.34l.292.141.192.844h0l-.191-.844-.293-.142Z",
    transform: "translate(-143.126 -62.185)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46054",
    "data-name": "Path 46054",
    d: "M271.48,152.005l.19.836,20.839-15.208-.18-.791-.343-.166L271.18,151.86Z",
    transform: "translate(-124.6 -62.799)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46055",
    "data-name": "Path 46055",
    d: "M310.014,136.229l.18.791.951-.694-.192-.844-.292-.141-.99.722Z",
    transform: "translate(-142.285 -62.185)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46056",
    "data-name": "Path 46056",
    d: "M253.711,166.1l-18.4,13.427.671.317.106.455,18.149-13.245-.178-.785Z",
    transform: "translate(-108.119 -76.319)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46057",
    "data-name": "Path 46057",
    d: "M271.48,164.911l.19.836-.19-.836-.3-.145Z",
    transform: "translate(-124.6 -75.706)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46058",
    "data-name": "Path 46058",
    d: "M269.7,165.658l.178.784.951-.694-.189-.836-.3-.145-.989.722Z",
    transform: "translate(-123.759 -75.706)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46059",
    "data-name": "Path 46059",
    d: "M212.815,201.091l.666.194,11.322-8.262-.092-.393-.731-.345-11.165,8.148Z",
    transform: "translate(-97.782 -88.35)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46060",
    "data-name": "Path 46060",
    d: "M235.982,191.258l-.67-.317Z",
    transform: "translate(-108.119 -87.732)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46061",
    "data-name": "Path 46061",
    d: "M236.659,191.983l-.106-.455Z",
    transform: "translate(-108.689 -88.002)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46062",
    "data-name": "Path 46062",
    d: "M233.472,191.668l.731.345.091.393.949-.692-.106-.456-.671-.316Z",
    transform: "translate(-107.274 -87.733)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46063",
    "data-name": "Path 46063",
    d: "M400.586,264.6l.3-1.038-20.71-6.034-.728.914Z",
    transform: "translate(-174.347 -118.326)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46064",
    "data-name": "Path 46064",
    d: "M336.3,244.774h0l-.7.877,22.581,6.58.728-.913-22.624-6.592Z",
    transform: "translate(-154.198 -112.445)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46065",
    "data-name": "Path 46065",
    d: "M379.45,258.439h0l.728-.913Z",
    transform: "translate(-174.347 -118.326)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46066",
    "data-name": "Path 46066",
    d: "M378.5,258.161l.728-.913-1.122-.327-.728.914Z",
    transform: "translate(-173.393 -118.048)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46067",
    "data-name": "Path 46067",
    d: "M336.878,244.774l-.011-.049Z",
    transform: "translate(-154.781 -112.445)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46068",
    "data-name": "Path 46068",
    d: "M286,230.191l-.633.8,26.033,7.586.648-.816-.029-.129-26.053-7.592Z",
    transform: "translate(-131.116 -105.697)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46069",
    "data-name": "Path 46069",
    d: "M335.6,245.693l.7-.877Z",
    transform: "translate(-154.198 -112.486)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46070",
    "data-name": "Path 46070",
    d: "M334.144,244.085l.029.129-.649.816,1.122.326.7-.876-.011-.05Z",
    transform: "translate(-153.245 -112.15)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46071",
    "data-name": "Path 46071",
    d: "M285.995,230.191l-.634.8h0l.633-.8-.034-.151h0Z",
    transform: "translate(-131.115 -105.697)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46072",
    "data-name": "Path 46072",
    d: "M242.181,217.522l-.566.7,22.526,6.564.585-.739-.052-.232-22.558-6.573Z",
    transform: "translate(-111.015 -99.815)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46073",
    "data-name": "Path 46073",
    d: "M283.289,230.37l1.121.326.633-.8-.035-.152-1.187-.346.053.232Z",
    transform: "translate(-130.163 -105.403)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46074",
    "data-name": "Path 46074",
    d: "M213.064,209.324l.306.672,14,4.079.52-.639-.084-.359-14.21-4.141Z",
    transform: "translate(-97.897 -96)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46075",
    "data-name": "Path 46075",
    d: "M242.181,217.522l-.566.7.566-.7-.066-.284Z",
    transform: "translate(-111.015 -99.815)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46076",
    "data-name": "Path 46076",
    d: "M239.53,217.6l1.126.328.566-.7-.066-.284-1.191-.347.084.36Z",
    transform: "translate(-110.057 -99.52)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46077",
    "data-name": "Path 46077",
    d: "M212.95,209.159l.531-.388-.666-.194v.288Z",
    transform: "translate(-97.783 -95.835)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46078",
    "data-name": "Path 46078",
    d: "M286.936,374.179h-.861l9.687,21.22h.607l.37-.463-9.595-21.018Z",
    transform: "translate(-131.443 -171.805)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46079",
    "data-name": "Path 46079",
    d: "M304.6,413.265H304l.426.933.984-.449-.433-.948Z",
    transform: "translate(-139.677 -189.671)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46080",
    "data-name": "Path 46080",
    d: "M267.1,331.729h-.2l9.871,21.621h.834l.225-.283-10.1-22.128Z",
    transform: "translate(-122.633 -152.058)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46081",
    "data-name": "Path 46081",
    d: "M286.934,374.174h-.862v0h.862l.208-.262v0Z",
    transform: "translate(-131.442 -171.803)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46082",
    "data-name": "Path 46082",
    d: "M286,372.16h-.834l.492,1.079h.862l.208-.26-.5-1.1Z",
    transform: "translate(-131.023 -170.867)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46083",
    "data-name": "Path 46083",
    d: "M244.669,282.185H244.2l11.776,25.8h.173l.645-.812-11.669-25.561-.456.576Z",
    transform: "translate(-112.203 -129.392)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46084",
    "data-name": "Path 46084",
    d: "M266.9,331.726v0h.2l.627-.789v0l-.626.789Z",
    transform: "translate(-122.632 -152.057)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46085",
    "data-name": "Path 46085",
    d: "M266.16,329.71h-.172l.492,1.079h.2l.626-.789-.5-1.1Z",
    transform: "translate(-122.214 -151.12)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46086",
    "data-name": "Path 46086",
    d: "M224.913,238.5h-.742L234.5,261.136h.44l.475-.6L225.2,238.151Z",
    transform: "translate(-103 -109.424)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17548",
    "data-name": "Rectangle 17548",
    width: 0.001,
    height: 0.735,
    transform: "translate(132.694 152.138)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46087",
    "data-name": "Path 46087",
    d: "M244.2,282.674h0Z",
    transform: "translate(-112.203 -129.881)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46088",
    "data-name": "Path 46088",
    d: "M243.727,280.164h-.44l.493,1.081h.469l.457-.576-.5-1.1Z",
    transform: "translate(-111.783 -128.452)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46089",
    "data-name": "Path 46089",
    d: "M211.819,211.186,218,224.731h.721l.3-.369L212.8,210.728l-.682-.2Z",
    transform: "translate(-97.325 -96.733)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46090",
    "data-name": "Path 46090",
    d: "M224.913,238.5h0l.286-.353Z",
    transform: "translate(-103 -109.424)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46091",
    "data-name": "Path 46091",
    d: "M223.98,236.49h-.721l.493,1.081h.741l.286-.352-.5-1.1Z",
    transform: "translate(-102.581 -108.491)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46092",
    "data-name": "Path 46092",
    d: "M212.369,210.127l.683.2-.307-.672-.241.176Z",
    transform: "translate(-97.577 -96.33)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46093",
    "data-name": "Path 46093",
    d: "M212.356,209.227h-.541l.492.223-.059.13.241-.176-.134-.295Z",
    transform: "translate(-97.323 -96.08)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17549",
    "data-name": "Rectangle 17549",
    width: 1.081,
    height: 14.594,
    transform: "translate(113.952 7.729)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17550",
    "data-name": "Rectangle 17550",
    width: 1.081,
    height: 13.513,
    transform: "translate(113.952 30.431)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17551",
    "data-name": "Rectangle 17551",
    width: 1.081,
    height: 18.918,
    transform: "translate(113.952 52.052)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17552",
    "data-name": "Rectangle 17552",
    width: 1.081,
    height: 15.675,
    transform: "translate(113.952 79.079)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46094",
    "data-name": "Path 46094",
    d: "M210.815,199.519l.541.4.54-.394V190.3h-1.081Z",
    transform: "translate(-96.864 -87.437)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46095",
    "data-name": "Path 46095",
    d: "M211.817,207.753l.243.178.3.086v-.658Z",
    transform: "translate(-97.324 -95.276)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46096",
    "data-name": "Path 46096",
    d: "M212.136,208.472l-.318.436.491-.224.049.106V208.5l-.3-.087Z",
    transform: "translate(-97.324 -95.762)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46097",
    "data-name": "Path 46097",
    d: "M211.816,209.136h0Zm0,0h.54v-.118l-.049-.106Z",
    transform: "translate(-97.323 -95.989)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46098",
    "data-name": "Path 46098",
    d: "M128.415,374.059l-.32-.4-9.735,21.519.082.1H119.5l9.6-21.22Z",
    transform: "translate(-54.383 -171.686)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46099",
    "data-name": "Path 46099",
    d: "M117.914,414l.985.445.4-.875h-1.058l-.082-.1Z",
    transform: "translate(-54.178 -189.977)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46100",
    "data-name": "Path 46100",
    d: "M147.2,332.187l-.2-.251-9.7,21.445.341.427h.653l9.782-21.621Z",
    transform: "translate(-63.084 -152.515)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46101",
    "data-name": "Path 46101",
    d: "M136.371,373.656l.32.4h.685l0,0h-.686l-.319-.4Z",
    transform: "translate(-62.658 -171.684)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46102",
    "data-name": "Path 46102",
    d: "M137.213,372.038l-.34-.427-.5,1.1.319.4h.686l.488-1.079Z",
    transform: "translate(-62.659 -170.745)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46103",
    "data-name": "Path 46103",
    d: "M168.275,282.295h0l-.354-.446-11.748,25.966.221.277h.841l11.672-25.8Z",
    transform: "translate(-71.757 -129.502)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46104",
    "data-name": "Path 46104",
    d: "M155.247,331.934l.2.251h.873v0h-.874l-.2-.251Z",
    transform: "translate(-71.332 -152.514)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46105",
    "data-name": "Path 46105",
    d: "M155.969,330.165l-.221-.277-.5,1.106.2.25h.874l.488-1.079Z",
    transform: "translate(-71.332 -151.574)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46106",
    "data-name": "Path 46106",
    d: "M177.908,281.848l.354.446-.354-.446Z",
    transform: "translate(-81.743 -129.502)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46107",
    "data-name": "Path 46107",
    d: "M189.242,238.547h0l-.245-.3-10.161,22.459.375.474h.6l10.24-22.632Z",
    transform: "translate(-82.17 -109.468)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46108",
    "data-name": "Path 46108",
    d: "M178.563,282.674h0Z",
    transform: "translate(-82.044 -129.881)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46109",
    "data-name": "Path 46109",
    d: "M179.381,280.271h-.6l-.375-.474-.5,1.109.354.446h.63Z",
    transform: "translate(-81.743 -128.559)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17553",
    "data-name": "Rectangle 17553",
    width: 0.805,
    height: 0.001,
    transform: "translate(107.072 129.079)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46110",
    "data-name": "Path 46110",
    d: "M205.423,210.521l-.67.188-6.2,13.7.261.321h.781l6.128-13.545Z",
    transform: "translate(-91.231 -96.728)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46111",
    "data-name": "Path 46111",
    d: "M197.879,238.548l-.245-.3Z",
    transform: "translate(-90.807 -109.468)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46112",
    "data-name": "Path 46112",
    d: "M199.174,236.531h-.781l-.261-.321-.5,1.1.244.3h.806Z",
    transform: "translate(-90.807 -108.532)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46113",
    "data-name": "Path 46113",
    d: "M211.261,210.45l.3.662.3-.657-.3-.088Z",
    transform: "translate(-97.068 -96.658)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46114",
    "data-name": "Path 46114",
    d: "M211.813,209.327l.146.52-.149.042.3.088.135-.3-.115.084-.319-.437Z",
    transform: "translate(-97.321 -96.18)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46115",
    "data-name": "Path 46115",
    d: "M211.815,209.327l.319.437.115-.084.059-.13-.492-.223Z",
    transform: "translate(-97.323 -96.18)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46116",
    "data-name": "Path 46116",
    d: "M.747,269.378l.04-.011-.066-.083Z",
    transform: "translate(-0.331 -123.728)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46117",
    "data-name": "Path 46117",
    d: "M24.237,256.027h0l.122-.533L2.283,261.676l-.118.517.416.522,22.063-6.178Z",
    transform: "translate(-0.994 -117.393)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46118",
    "data-name": "Path 46118",
    d: "M.787,269.367l-.066-.083Z",
    transform: "translate(-0.331 -123.729)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46119",
    "data-name": "Path 46119",
    d: "M.23,267.256.5,268.2l.066.083,1.131-.316-.417-.522.118-.517Z",
    transform: "translate(-0.106 -122.647)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46120",
    "data-name": "Path 46120",
    d: "M43,256.027l.122-.532Z",
    transform: "translate(-19.757 -117.393)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46121",
    "data-name": "Path 46121",
    d: "M67.237,244.179h0l.171-.75L45.3,249.619l-.137.6.366.46,21.98-6.154Z",
    transform: "translate(-20.751 -111.849)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46122",
    "data-name": "Path 46122",
    d: "M43.407,256.991l-.406-.51Z",
    transform: "translate(-19.757 -117.846)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46123",
    "data-name": "Path 46123",
    d: "M44.536,255.939l-.366-.46.136-.6-1.184.332-.122.533.406.51Z",
    transform: "translate(-19.757 -117.111)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46124",
    "data-name": "Path 46124",
    d: "M86,244.179l.171-.75Z",
    transform: "translate(-39.514 -111.849)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46125",
    "data-name": "Path 46125",
    d: "M114.613,229.776h0l.145-.641-26.41,7.394-.186.816.234.293,26.554-7.435Z",
    transform: "translate(-40.508 -105.281)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46126",
    "data-name": "Path 46126",
    d: "M86.274,245.161,86,244.817Z",
    transform: "translate(-39.514 -112.487)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46127",
    "data-name": "Path 46127",
    d: "M87.4,243.924l-.234-.294.185-.816-1.184.332-.17.75.273.344Z",
    transform: "translate(-39.515 -111.567)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46128",
    "data-name": "Path 46128",
    d: "M161.8,217.352h0l.112-.484-22.5,6.3-.16.706.3.377,22.69-6.353Z",
    transform: "translate(-63.986 -99.645)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46129",
    "data-name": "Path 46129",
    d: "M137.436,230.748h0l-.339-.428Z",
    transform: "translate(-62.992 -105.826)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46130",
    "data-name": "Path 46130",
    d: "M137.1,229.775h0l.145-.641Z",
    transform: "translate(-62.992 -105.282)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46131",
    "data-name": "Path 46131",
    d: "M138.565,229.605l-.3-.377.161-.706-1.184.331-.145.641.339.428Z",
    transform: "translate(-62.992 -104.999)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46132",
    "data-name": "Path 46132",
    d: "M180.968,217.352l.113-.484Z",
    transform: "translate(-83.15 -99.645)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46133",
    "data-name": "Path 46133",
    d: "M197.966,209.317l-.544-.4-14.156,3.964-.127.545.406.5,14.125-3.955Z",
    transform: "translate(-84.147 -95.993)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46134",
    "data-name": "Path 46134",
    d: "M181.412,218.308l-.444-.545Z",
    transform: "translate(-83.15 -100.056)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46135",
    "data-name": "Path 46135",
    d: "M182.548,217.3l-.406-.5.127-.545-1.188.332-.112.484.444.545Z",
    transform: "translate(-83.15 -99.362)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46136",
    "data-name": "Path 46136",
    d: "M210.557,209.83l-.24-.176-.3.656.67-.188Z",
    transform: "translate(-96.498 -96.331)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46137",
    "data-name": "Path 46137",
    d: "M211.128,209.764l-.115-.084.134.292.3-.083-.148-.043.151-.518Z",
    transform: "translate(-96.955 -96.181)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46138",
    "data-name": "Path 46138",
    d: "M211.536,209.846l.149.043.148-.042-.146-.52Z",
    transform: "translate(-97.195 -96.181)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46139",
    "data-name": "Path 46139",
    d: "M61.309,98.54l.129-.062L43.995,85.721l-.441.212-.158.69L61.077,99.555Z",
    transform: "translate(-19.939 -39.386)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46140",
    "data-name": "Path 46140",
    d: "M43.312,85.247l-.764-.558-.638.873.8.588.158-.69Z",
    transform: "translate(-19.256 -38.912)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46141",
    "data-name": "Path 46141",
    d: "M95.692,124.142h0l.605-.292L78.264,110.661l-.179.087-.219.962L95.574,124.66Z",
    transform: "translate(-35.777 -50.846)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46142",
    "data-name": "Path 46142",
    d: "M76.107,110.4h0l.231-1.015Zm.36-1.077-.129.062.129-.062Z",
    transform: "translate(-34.969 -50.231)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46143",
    "data-name": "Path 46143",
    d: "M77.456,110.046l-.989-.723-.129.062-.231,1.015.95.695.219-.962Z",
    transform: "translate(-34.969 -50.231)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46144",
    "data-name": "Path 46144",
    d: "M110.846,135.353l.605-.292Z",
    transform: "translate(-50.93 -62.057)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46145",
    "data-name": "Path 46145",
    d: "M133.742,151.877l.342-.166L113.147,136.4l-.655.316-.106.466,21.177,15.488Z",
    transform: "translate(-51.638 -62.672)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46146",
    "data-name": "Path 46146",
    d: "M110.627,136.12h0l.118-.518Z",
    transform: "translate(-50.83 -62.305)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46147",
    "data-name": "Path 46147",
    d: "M111.578,136.567l.106-.466.655-.317-.989-.723-.6.292-.118.519Z",
    transform: "translate(-50.83 -62.057)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46148",
    "data-name": "Path 46148",
    d: "M172.257,179.5l-18.375-13.439-.391.189-.168.742,18.144,13.27.1-.437Z",
    transform: "translate(-70.447 -76.302)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46149",
    "data-name": "Path 46149",
    d: "M151.743,164.894l-.179.792h0l.18-.792.342-.166h0Z",
    transform: "translate(-69.639 -75.688)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46150",
    "data-name": "Path 46150",
    d: "M152.683,165.64l.391-.189-.988-.723-.342.166-.18.792.95.7Z",
    transform: "translate(-69.64 -75.688)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46151",
    "data-name": "Path 46151",
    d: "M200.628,201.08v-.656l-11.149-8.154-.748.352-.088.377,11.307,8.27Z",
    transform: "translate(-86.677 -88.343)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46152",
    "data-name": "Path 46152",
    d: "M186.992,191.251l.688-.325-.688.325-.1.437Z",
    transform: "translate(-85.871 -87.725)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46153",
    "data-name": "Path 46153",
    d: "M188.673,191.653l-.993-.726-.688.325-.1.437.948.693.088-.376Z",
    transform: "translate(-85.87 -87.726)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46154",
    "data-name": "Path 46154",
    d: "M211.815,209.327h0Z",
    transform: "translate(-97.323 -96.18)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46155",
    "data-name": "Path 46155",
    d: "M211.356,207.752l-.541-.4v.656l.3-.084Z",
    transform: "translate(-96.864 -95.275)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46156",
    "data-name": "Path 46156",
    d: "M211.371,208.264l.095-.027.145.52.151-.518.092.027-.243-.178Z",
    transform: "translate(-97.119 -95.611)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46157",
    "data-name": "Path 46157",
    d: "M211.815,208.886h0l.318-.436-.076-.056-.092-.026Z",
    transform: "translate(-97.323 -95.739)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46158",
    "data-name": "Path 46158",
    d: "M211.815,209.327h0Z",
    transform: "translate(-97.323 -96.18)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46159",
    "data-name": "Path 46159",
    d: "M211.815,209.328h0Z",
    transform: "translate(-97.323 -96.18)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46160",
    "data-name": "Path 46160",
    d: "M211.815,209.327h0Z",
    transform: "translate(-97.323 -96.18)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46161",
    "data-name": "Path 46161",
    d: "M210.24,208.569l-.677.189.544.4.133-.294Z",
    transform: "translate(-96.288 -95.832)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46162",
    "data-name": "Path 46162",
    d: "M210.815,208.5v.294l.048-.107.492.223-.319-.436.079-.058Z",
    transform: "translate(-96.863 -95.76)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46163",
    "data-name": "Path 46163",
    d: "M211.3,208.391l-.079.057.319.436-.145-.52Z",
    transform: "translate(-97.052 -95.738)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46164",
    "data-name": "Path 46164",
    d: "M210.569,209.405l.241.175-.059-.129.492-.224H210.7v-.116Z",
    transform: "translate(-96.751 -96.081)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46165",
    "data-name": "Path 46165",
    d: "M210.905,209.551l.059.129.114.084.319-.436h0Z",
    transform: "translate(-96.905 -96.18)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46166",
    "data-name": "Path 46166",
    d: "M211.815,209.328h0Z",
    transform: "translate(-97.323 -96.18)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46167",
    "data-name": "Path 46167",
    d: "M210.815,209.021v.116h.541l-.492-.223Z",
    transform: "translate(-96.863 -95.991)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46894",
    "data-name": "Group 46894",
    transform: "translate(29.778 51.265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45788",
    "data-name": "Group 45788",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45300",
    "data-name": "Path 45300",
    d: "M82,0,148.81,17.963l-.085.6L140.231,78.6l26.152,71.183L82.369,195.226,70.322,99.494,0,37.083l.966-.437Zm65.277,18.975L82.12,1.455,2.5,37.462,71.621,98.809l.032.257,11.828,94,81.2-43.923L138.822,78.747l.024-.171Z",
    transform: "translate(0 166.155) rotate(-87)",
    fill: "#13dbb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45303",
    "data-name": "Path 45303",
    d: "M0,36.52l69.879,61.9,11.52,95.6L164.552,148.8,138.434,77.945l8.518-60.2L80.969,0Z",
    transform: "translate(0.784 165.102) rotate(-87)",
    fill: "#13dbb5",
    opacity: 0.283
  }))))))))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48773",
    "data-name": "Group 48773",
    transform: "translate(2151 2969.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 683.77, 802)",
    filter: "url(#Rectangle_17531)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17531-3",
    "data-name": "Rectangle 17531",
    width: 472,
    height: 109,
    rx: 30,
    transform: "translate(214.23 399)",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_45991",
    "data-name": "Group 45991",
    transform: "translate(922.467 1228.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52409",
    "data-name": "Path 52409",
    d: "M6.94,0V-11.28h4.04v-2.06H.56v2.06H4.6V0ZM13.5,0V-6.58a3.336,3.336,0,0,1,2.48-1.28,3.1,3.1,0,0,1,.66.06V-9.88A4.125,4.125,0,0,0,13.5-8.24V-9.66H11.4V0Zm4.24-4.84A4.856,4.856,0,0,0,22.8.24a5.631,5.631,0,0,0,3.92-1.4l-.96-1.38a4.088,4.088,0,0,1-2.74,1.06,2.926,2.926,0,0,1-3.08-2.66H27.4v-.5c0-3.04-1.86-5.26-4.76-5.26A4.882,4.882,0,0,0,17.74-4.84Zm4.9-3.34a2.584,2.584,0,0,1,2.72,2.56H19.92A2.665,2.665,0,0,1,22.64-8.18ZM38.1,0V-6.8a2.784,2.784,0,0,0-3.12-3.1,4.57,4.57,0,0,0-3.4,1.56V-9.66h-2.1V0h2.1V-6.74a3.18,3.18,0,0,1,2.48-1.3c1.18,0,1.94.5,1.94,2V0ZM49.72,0V-13.34h-2.1v5.02a3.875,3.875,0,0,0-3.1-1.58c-2.5,0-4.3,1.96-4.3,5.08,0,3.18,1.82,5.06,4.3,5.06a3.912,3.912,0,0,0,3.1-1.56V0Zm-2.1-2.9a3.156,3.156,0,0,1-2.5,1.28c-1.66,0-2.72-1.34-2.72-3.2,0-1.88,1.06-3.22,2.72-3.22a3.174,3.174,0,0,1,2.5,1.3ZM65.86,0V-2.06H59.98V-13.34H57.64V0Zm3.1-11.26a1.3,1.3,0,0,0,1.3-1.3,1.3,1.3,0,0,0-1.3-1.3,1.31,1.31,0,0,0-1.3,1.3A1.31,1.31,0,0,0,68.96-11.26ZM70.02,0V-9.66h-2.1V0ZM81.36,0V-6.8a2.784,2.784,0,0,0-3.12-3.1,4.57,4.57,0,0,0-3.4,1.56V-9.66h-2.1V0h2.1V-6.74a3.18,3.18,0,0,1,2.48-1.3c1.18,0,1.94.5,1.94,2V0Zm2.12-4.84A4.856,4.856,0,0,0,88.54.24a5.631,5.631,0,0,0,3.92-1.4L91.5-2.54a4.088,4.088,0,0,1-2.74,1.06,2.926,2.926,0,0,1-3.08-2.66h7.46v-.5c0-3.04-1.86-5.26-4.76-5.26A4.882,4.882,0,0,0,83.48-4.84Zm4.9-3.34A2.584,2.584,0,0,1,91.1-5.62H85.66A2.665,2.665,0,0,1,88.38-8.18Z",
    transform: "translate(0.157 18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52410",
    "data-name": "Path 52410",
    d: "M.408-1.632A5.255,5.255,0,0,0,4.692.2c2.618,0,4.267-1.377,4.267-3.3A2.849,2.849,0,0,0,6.324-5.848a2.77,2.77,0,0,0,2.465-2.6c0-1.9-1.649-3.06-4.1-3.06A5.25,5.25,0,0,0,.561-9.724l1.02,1.241A3.987,3.987,0,0,1,4.5-9.741c1.275,0,2.3.544,2.3,1.6,0,1.037-1,1.5-2.329,1.5-.442,0-1.105,0-1.309-.017v1.785c.17-.017.833-.017,1.309-.017,1.615,0,2.516.476,2.516,1.6,0,1.054-.867,1.734-2.363,1.734A4.233,4.233,0,0,1,1.479-2.941ZM10.642-1a1.2,1.2,0,0,0,1.19,1.19A1.2,1.2,0,0,0,13.022-1a1.2,1.2,0,0,0-1.19-1.19A1.2,1.2,0,0,0,10.642-1Zm4.233-.544A5.181,5.181,0,0,0,19.091.2c2.533,0,4.318-1.479,4.318-3.842a3.516,3.516,0,0,0-3.621-3.655,3.694,3.694,0,0,0-2.567.986V-9.588h5.44v-1.751H15.232V-5l1.411.408a3.41,3.41,0,0,1,2.482-.986A2.022,2.022,0,0,1,21.4-3.553a2.091,2.091,0,0,1-2.329,1.989,3.912,3.912,0,0,1-3.06-1.343ZM24.6-8.67A2.692,2.692,0,0,0,27.4-5.882,2.71,2.71,0,0,0,30.243-8.67,2.741,2.741,0,0,0,27.4-11.509,2.723,2.723,0,0,0,24.6-8.67ZM27.438,0,34.7-11.339H33.558L26.316,0Zm1.479-8.67A1.536,1.536,0,0,1,27.4-7a1.533,1.533,0,0,1-1.5-1.666,1.535,1.535,0,0,1,1.5-1.7A1.538,1.538,0,0,1,28.917-8.67ZM30.7-2.584A2.692,2.692,0,0,0,33.507.2a2.705,2.705,0,0,0,2.822-2.788,2.737,2.737,0,0,0-2.822-2.839A2.723,2.723,0,0,0,30.7-2.584Zm4.318,0A1.527,1.527,0,0,1,33.507-.918a1.514,1.514,0,0,1-1.5-1.666,1.526,1.526,0,0,1,1.5-1.7A1.538,1.538,0,0,1,35.02-2.584Z",
    transform: "translate(17.33 49.386)",
    fill: "#13dbb5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-arrow-down",
    "data-name": "Icon feather-arrow-down",
    transform: "translate(11.214 49.386) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45246",
    "data-name": "Path 45246",
    d: "M0,0V11",
    transform: "translate(5.607)",
    fill: "none",
    stroke: "#13dbb5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45247",
    "data-name": "Path 45247",
    d: "M11.214,0,5.607,5.5,0,0",
    transform: "translate(0 5.5)",
    fill: "none",
    stroke: "#13dbb5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_45989",
    "data-name": "Path 45989",
    d: "M2.462,42.638a36.748,36.748,0,0,0,10.087-4.749c2.532-1.8,5.022-4.188,8.159-5.064,3.266-.911,6.537.444,9.379,1.848,2.926,1.446,5.778,3.1,9.012,3.909a52.287,52.287,0,0,0,10.677,1.091c3.609.144,7.219.485,10.282,2.408,4.344,2.725,7.152,7.091,10.9,10.406,4.076,3.6,9.095,5.457,14.748,4.34a22.281,22.281,0,0,0,11.758-6.537c6.129-6.507,8.372-15.234,11.129-23.251,1.162-3.381,2.368-6.874,4.529-9.845,1.915-2.631,4.562-4.248,8.1-2.68,4.774,2.117,7.913,6.946,11.311,10.5a31.755,31.755,0,0,0,15.554,8.9,34.537,34.537,0,0,0,20.92-1.664c5.809-2.392,10.133-6.511,15.293-9.805a19.354,19.354,0,0,1,7.965-3.228,15.337,15.337,0,0,1,8.812,1.825c5.657,2.923,9.722,7.8,14.587,11.645,5.365,4.238,11.527,6.818,18.73,6.349,5.9-.384,11.972-2.527,16.2-6.428,7.914-7.307,11.35-17.7,18.718-25.4a17.1,17.1,0,0,1,5.118-3.864c2.258-1.047.272-4.172-1.982-3.126-4.543,2.108-7.736,6.22-10.456,10.04-3.208,4.506-5.932,9.286-9.13,13.8-2.894,4.084-6.049,7.606-10.981,9.623a22.935,22.935,0,0,1-19.481-.8c-5.538-3.081-9.566-8.079-14.523-11.837-4.94-3.747-10.87-6.425-17.4-5.2-6.112,1.148-10.82,5.362-15.545,8.8A32.106,32.106,0,0,1,156.653,31.2a28.691,28.691,0,0,1-18.373-5.961c-4.1-3.3-6.935-7.719-10.946-11.107-3.452-2.916-8.536-5.311-13.063-2.9-3.122,1.661-5.131,4.649-6.567,7.605-3.669,7.551-5.04,15.9-9.095,23.306a22.588,22.588,0,0,1-8.048,8.953C86.541,53.464,81.338,54.569,77,52.257c-4.474-2.387-7.339-6.762-10.888-10.1a21.106,21.106,0,0,0-7.3-4.732c-3.363-1.2-7.037-1.3-10.6-1.424a31.066,31.066,0,0,1-10.236-1.583c-3.076-1.189-5.822-2.994-8.894-4.2a14.893,14.893,0,0,0-9.642-.822c-3.2.956-5.757,3.045-8.329,4.953a33.144,33.144,0,0,1-9.7,4.8,1.823,1.823,0,1,0,1.045,3.491",
    transform: "translate(1064.192 1220.314)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46004",
    "data-name": "Group 46004",
    transform: "translate(1067.125 1220.314)",
    opacity: 0.117
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46002",
    "data-name": "Group 46002"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45990",
    "data-name": "Path 45990",
    d: "M275.35,0c-10.89,5.1-17.838,28.573-28.331,34.047-8.505,4.913-19.609,4.871-27.314-1.5-7.479-5.557-13.907-15.219-23.97-16.071-10.583-.722-17.029,9.552-25.891,13.456C160.1,34.7,147.816,34,139.011,27.7c-7.358-4.246-13.408-18.8-22.9-16.6-13.453,5.1-8.84,40.312-31.685,45.279-12.2,2.438-16.132-9.908-24.483-15.4-6.29-4.176-14.308-1.921-21.277-3.784-6.541-1.423-12-7.514-19.055-6.453C14.485,31.6,10.725,36.655,5.9,39A41.832,41.832,0,0,1,0,41.375v25H275.35Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }))))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48774",
    "data-name": "Group 48774",
    transform: "translate(-2094 -83.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4928.77, 3855)",
    filter: "url(#Rectangle_17531-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17531-4",
    "data-name": "Rectangle 17531",
    width: 487,
    height: 123,
    rx: 20,
    transform: "translate(442.23 79)",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_52403",
    "data-name": "Path 52403",
    d: "M8.18,0l5.24-13.34H10.76L6.72-2.54,2.68-13.34H.02L5.26,0Zm7.68-11.26a1.3,1.3,0,0,0,1.3-1.3,1.3,1.3,0,0,0-1.3-1.3,1.31,1.31,0,0,0-1.3,1.3A1.31,1.31,0,0,0,15.86-11.26ZM16.92,0V-9.66h-2.1V0Zm2.12-4.84A4.856,4.856,0,0,0,24.1.24a5.631,5.631,0,0,0,3.92-1.4l-.96-1.38a4.088,4.088,0,0,1-2.74,1.06,2.926,2.926,0,0,1-3.08-2.66H28.7v-.5c0-3.04-1.86-5.26-4.76-5.26A4.882,4.882,0,0,0,19.04-4.84Zm4.9-3.34a2.584,2.584,0,0,1,2.72,2.56H21.22A2.665,2.665,0,0,1,23.94-8.18ZM41.4,0l3-9.66H42.22L40.18-2.64l-2.3-7.02H36.04l-2.3,7.02L31.7-9.66H29.52l3,9.66h2.2l2.24-7.08L39.2,0Zm3.62-1.26A5.875,5.875,0,0,0,49.16.24c2.6,0,4.02-1.3,4.02-3,0-2.28-2.06-2.76-3.74-3.12-1.14-.26-2.1-.52-2.1-1.26,0-.68.7-1.08,1.8-1.08A3.9,3.9,0,0,1,52-7.06l.88-1.48A5.522,5.522,0,0,0,49.12-9.9c-2.44,0-3.8,1.36-3.8,2.94,0,2.16,1.98,2.6,3.64,2.96,1.18.26,2.2.56,2.2,1.4,0,.72-.64,1.18-1.9,1.18a4.986,4.986,0,0,1-3.28-1.36Z",
    transform: "translate(5425.692 3981.778)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52406",
    "data-name": "Path 52406",
    d: "M.82-6.66A6.618,6.618,0,0,0,7.64.24a6.618,6.618,0,0,0,6.82-6.9,6.618,6.618,0,0,0-6.82-6.9A6.618,6.618,0,0,0,.82-6.66Zm11.24,0c0,2.74-1.74,4.82-4.42,4.82-2.7,0-4.42-2.08-4.42-4.82,0-2.76,1.72-4.82,4.42-4.82C10.32-11.48,12.06-9.42,12.06-6.66Zm6.7,5.32A3.793,3.793,0,0,0,21.86.24c2.5,0,4.28-1.9,4.28-5.08S24.36-9.9,21.86-9.9a3.855,3.855,0,0,0-3.1,1.56V-9.66h-2.1V3.68h2.1Zm5.2-3.5c0,1.88-1.06,3.22-2.72,3.22a3.192,3.192,0,0,1-2.48-1.3V-6.74a3.135,3.135,0,0,1,2.48-1.3C22.9-8.04,23.96-6.7,23.96-4.84Zm3.7,0A4.856,4.856,0,0,0,32.72.24a5.631,5.631,0,0,0,3.92-1.4l-.96-1.38a4.088,4.088,0,0,1-2.74,1.06,2.926,2.926,0,0,1-3.08-2.66h7.46v-.5c0-3.04-1.86-5.26-4.76-5.26A4.882,4.882,0,0,0,27.66-4.84Zm4.9-3.34a2.584,2.584,0,0,1,2.72,2.56H29.84A2.665,2.665,0,0,1,32.56-8.18ZM48.02,0V-6.8A2.784,2.784,0,0,0,44.9-9.9a4.57,4.57,0,0,0-3.4,1.56V-9.66H39.4V0h2.1V-6.74a3.18,3.18,0,0,1,2.48-1.3c1.18,0,1.94.5,1.94,2V0ZM49.9-1.26A5.875,5.875,0,0,0,54.04.24c2.6,0,4.02-1.3,4.02-3,0-2.28-2.06-2.76-3.74-3.12-1.14-.26-2.1-.52-2.1-1.26,0-.68.7-1.08,1.8-1.08a3.9,3.9,0,0,1,2.86,1.16l.88-1.48A5.522,5.522,0,0,0,54-9.9c-2.44,0-3.8,1.36-3.8,2.94,0,2.16,1.98,2.6,3.64,2.96,1.18.26,2.2.56,2.2,1.4,0,.72-.64,1.18-1.9,1.18a4.986,4.986,0,0,1-3.28-1.36Z",
    transform: "translate(5555.271 3981.778)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52407",
    "data-name": "Path 52407",
    d: "M8.16,0c2.5,0,3.88-1.54,3.88-3.6A3.281,3.281,0,0,0,9.46-6.88a3,3,0,0,0,2.32-3.06c0-1.88-1.36-3.4-3.8-3.4H1.42V0ZM3.76-11.28H7.5A1.7,1.7,0,0,1,9.38-9.54,1.685,1.685,0,0,1,7.5-7.82H3.76Zm0,5.52H7.6A1.833,1.833,0,0,1,9.64-3.92,1.8,1.8,0,0,1,7.6-2.06H3.76ZM22.94,0V-9.66h-2.1v6.78a3.213,3.213,0,0,1-2.48,1.26c-1.18,0-1.94-.46-1.94-1.96V-9.66h-2.1v6.84c0,1.98,1.02,3.06,3.1,3.06a4.63,4.63,0,0,0,3.42-1.52V0Zm5.62.24a2.77,2.77,0,0,0,1.98-.62l-.5-1.58a1.356,1.356,0,0,1-.94.34c-.6,0-.92-.48-.92-1.14V-7.82h1.96V-9.66H28.18V-12.3h-2.1v2.64h-1.6v1.84h1.6v5.58A2.228,2.228,0,0,0,28.56.24Zm6.38,0a2.77,2.77,0,0,0,1.98-.62l-.5-1.58a1.356,1.356,0,0,1-.94.34c-.6,0-.92-.48-.92-1.14V-7.82h1.96V-9.66H34.56V-12.3h-2.1v2.64h-1.6v1.84h1.6v5.58A2.228,2.228,0,0,0,34.94.24Zm7.84,0a4.834,4.834,0,0,0,4.98-5.08A4.829,4.829,0,0,0,42.78-9.9a4.836,4.836,0,0,0-4.96,5.06A4.841,4.841,0,0,0,42.78.24Zm0-1.86C41-1.62,40-3.12,40-4.84c0-1.7,1-3.2,2.78-3.2,1.8,0,2.8,1.5,2.8,3.2C45.58-3.12,44.58-1.62,42.78-1.62ZM58.5,0V-6.8a2.784,2.784,0,0,0-3.12-3.1,4.57,4.57,0,0,0-3.4,1.56V-9.66h-2.1V0h2.1V-6.74a3.18,3.18,0,0,1,2.48-1.3c1.18,0,1.94.5,1.94,2V0ZM72.72.24a6.1,6.1,0,0,0,5.46-3l-2-1.02a3.961,3.961,0,0,1-3.46,1.94,4.55,4.55,0,0,1-4.5-4.82,4.55,4.55,0,0,1,4.5-4.82,4,4,0,0,1,3.46,1.94l2-1.02a6.081,6.081,0,0,0-5.46-3,6.705,6.705,0,0,0-6.9,6.9A6.705,6.705,0,0,0,72.72.24ZM82.1,0V-13.34H80V0Zm3.76-11.26a1.3,1.3,0,0,0,1.3-1.3,1.3,1.3,0,0,0-1.3-1.3,1.31,1.31,0,0,0-1.3,1.3A1.31,1.31,0,0,0,85.86-11.26ZM86.92,0V-9.66h-2.1V0Zm2.12-4.84a4.853,4.853,0,0,0,5,5.08,4.332,4.332,0,0,0,3.7-1.72L96.36-2.76a2.626,2.626,0,0,1-2.22,1.14,2.933,2.933,0,0,1-2.92-3.22,2.916,2.916,0,0,1,2.92-3.2A2.578,2.578,0,0,1,96.36-6.9l1.38-1.28a4.332,4.332,0,0,0-3.7-1.72A4.848,4.848,0,0,0,89.04-4.84ZM108.62,0l-4.1-5.28,4.02-4.38h-2.6L101.68-5v-8.34h-2.1V0h2.1V-2.6l1.34-1.38L105.98,0Zm.44-1.26A5.875,5.875,0,0,0,113.2.24c2.6,0,4.02-1.3,4.02-3,0-2.28-2.06-2.76-3.74-3.12-1.14-.26-2.1-.52-2.1-1.26,0-.68.7-1.08,1.8-1.08a3.9,3.9,0,0,1,2.86,1.16l.88-1.48a5.522,5.522,0,0,0-3.76-1.36c-2.44,0-3.8,1.36-3.8,2.94,0,2.16,1.98,2.6,3.64,2.96,1.18.26,2.2.56,2.2,1.4,0,.72-.64,1.18-1.9,1.18a4.986,4.986,0,0,1-3.28-1.36Z",
    transform: "translate(5702.297 3981.778)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-mouse-pointer",
    "data-name": "Icon feather-mouse-pointer",
    transform: "translate(5531.599 3969.849)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28863",
    "data-name": "Path 28863",
    d: "M4.5,4.5l5.782,13.879,2.053-6.044,6.044-2.053Z",
    transform: "translate(-4.5 -4.5)",
    fill: "none",
    stroke: "#7a849c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28864",
    "data-name": "Path 28864",
    d: "M19.5,19.5l4.907,4.907",
    transform: "translate(-11.321 -11.321)",
    fill: "none",
    stroke: "#7a849c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_52404",
    "data-name": "Path 52404",
    d: "M11.04,0V-21.344H7.072L.352-14.592l2.592,2.72,3.52-3.616V0Zm3.616-2.24A2.623,2.623,0,0,0,17.248.352,2.623,2.623,0,0,0,19.84-2.24a2.623,2.623,0,0,0-2.592-2.592A2.623,2.623,0,0,0,14.656-2.24Zm8.256-.576c1.824,1.984,4.512,3.2,8.224,3.2,5.152,0,8.544-2.848,8.544-7.36a6.644,6.644,0,0,0-6.848-6.88,7.355,7.355,0,0,0-4.8,1.76V-17.44H38.24v-3.9H23.584V-9.152l3.168.864a6.152,6.152,0,0,1,4.48-1.76c2.432,0,3.84,1.312,3.84,3.264,0,1.76-1.44,3.2-3.968,3.2a7.794,7.794,0,0,1-5.7-2.3ZM66.048,0V-21.344h-6.4L54.464-8.032,49.28-21.344H42.912V0h4.544V-15.36L53.472,0h1.984l6.016-15.36V0Z",
    transform: "translate(5399.951 4024.067)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52405",
    "data-name": "Path 52405",
    d: "M8.864,0,16.8-18.176v-3.168H.768v4H11.52L3.872,0ZM35.008,0V-4h-8.9c5.728-4.032,8.736-7.2,8.736-10.848,0-4.256-3.616-6.816-8.16-6.816a10.872,10.872,0,0,0-8.224,3.488l2.592,3.008a7.611,7.611,0,0,1,5.7-2.464c1.792,0,3.488.928,3.488,2.784,0,2.624-2.56,4.832-11.3,11.264V0ZM52.192,0V-4.416h2.752v-4H52.192V-21.344H45.92L37.44-8v3.584H47.648V0ZM47.648-8.416h-5.76l5.76-8.9Z",
    transform: "translate(5529.645 4024.067)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52408",
    "data-name": "Path 52408",
    d: "M17.019,0V-3.875H8.4c5.549-3.906,8.463-6.975,8.463-10.509,0-4.123-3.5-6.6-7.9-6.6A10.533,10.533,0,0,0,.992-17.608L3.5-14.694a7.373,7.373,0,0,1,5.518-2.387c1.736,0,3.379.9,3.379,2.7C12.4-11.842,9.92-9.7,1.457-3.472V0Zm2.666-5.363c0,3.875,3.968,5.735,8.308,5.735S36.3-1.519,36.3-5.363c0-2.511-1.984-4.433-4.464-5.3,2.294-.775,4.123-2.294,4.123-4.867,0-3.875-4.154-5.456-7.967-5.456-3.844,0-7.967,1.581-7.967,5.456,0,2.573,1.8,4.092,4.092,4.867C21.638-9.8,19.685-7.874,19.685-5.363Zm11.78-9.486c0,1.612-2.2,2.325-3.472,2.511-1.271-.186-3.5-.9-3.5-2.511,0-1.457,1.457-2.356,3.5-2.356C30.008-17.2,31.465-16.306,31.465-14.849Zm.372,8.959c0,1.519-1.736,2.48-3.844,2.48-2.17,0-3.844-.961-3.844-2.48,0-1.8,2.542-2.666,3.844-2.821C29.264-8.556,31.837-7.688,31.837-5.89Zm6.6-4.4C38.44-4.464,41.075.372,47.368.372c4.712,0,7.9-3.069,7.9-7.1,0-4.4-3.317-6.665-7.037-6.665a6.7,6.7,0,0,0-5.3,2.635,1.906,1.906,0,0,1-.031-.434c0-3.286,2.046-5.983,5.177-5.983A5.505,5.505,0,0,1,52.2-15.531l1.984-3.317a9.331,9.331,0,0,0-6.107-2.139C41.974-20.987,38.44-16.554,38.44-10.292ZM50.809-6.541c0,1.457-1.271,3.069-3.658,3.069-2.914,0-4.03-2.294-4.216-4.278a5.3,5.3,0,0,1,4.03-1.984C48.98-9.734,50.809-8.773,50.809-6.541Z",
    transform: "translate(5664.675 4024.067)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46926",
    "data-name": "Group 46926",
    transform: "translate(5666.63 3969.868)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44594",
    "data-name": "Group 44594",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44927",
    "data-name": "Path 44927",
    d: "M15.955,10.6H5.8A4.8,4.8,0,1,1,5.8,1H20.208a4.8,4.8,0,1,1,0,9.6h-.252",
    transform: "translate(0.245 0.246)",
    fill: "none",
    stroke: "#7a849c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44928",
    "data-name": "Path 44928",
    d: "M12.237,7.082,16.408,17.1l1.481-4.361,4.363-1.482Z",
    transform: "translate(3.003 1.738)",
    fill: "none",
    stroke: "#7a849c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1324",
    "data-name": "Line 1324",
    x2: 3.541,
    y2: 3.541,
    transform: "translate(21.142 14.722)",
    fill: "none",
    stroke: "#7a849c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-eye",
    "data-name": "Icon feather-eye",
    transform: "translate(5399.951 3970.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28861",
    "data-name": "Path 28861",
    d: "M1.5,11.8S4.4,6,9.474,6s7.974,5.8,7.974,5.8-2.9,5.8-7.974,5.8S1.5,11.8,1.5,11.8Z",
    transform: "translate(-1.5 -6)",
    fill: "none",
    stroke: "#7a849c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28862",
    "data-name": "Path 28862",
    d: "M17.85,15.675A2.175,2.175,0,1,1,15.675,13.5,2.175,2.175,0,0,1,17.85,15.675Z",
    transform: "translate(-7.701 -9.875)",
    fill: "none",
    stroke: "#7a849c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_1458",
    "data-name": "Line 1458",
    y2: 59.896,
    transform: "translate(5507.909 3966.875)",
    fill: "none",
    stroke: "#78849e",
    strokeWidth: 1,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1459",
    "data-name": "Line 1459",
    y2: 59.896,
    transform: "translate(5642.939 3966.875)",
    fill: "none",
    stroke: "#78849e",
    strokeWidth: 1,
    opacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardsGraphic);
export default __webpack_public_path__ + "static/media/dashboards_graphic.334110870c32ba42b18e826225b08de9.svg";
export { ForwardRef as ReactComponent };